const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1920px",
    height: "1200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d3d3d3",
    d: "M 327.5,316.5 C 240.665,316.167 153.998,316.501 67.5,317.5C 66.5006,410.999 66.1673,504.665 66.5,598.5C 65.3342,504.668 65.1676,410.668 66,316.5C 153.264,315.167 240.431,315.167 327.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#c7c7c7",
    d: "M 327.5,316.5 C 330.495,316.294 333.162,316.96 335.5,318.5C 332.572,318.435 329.905,317.768 327.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3a3a3",
    d: "M 666.5,316.5 C 667.5,317.167 668.5,317.833 669.5,318.5C 667.833,318.5 666.167,318.5 664.5,318.5C 609.336,317.501 554.003,317.168 498.5,317.5C 498.167,317.5 497.833,317.5 497.5,317.5C 493.466,317.505 489.466,317.838 485.5,318.5C 488.796,317.089 492.296,316.089 496,315.5C 552.795,315.173 609.628,315.507 666.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#a3a3a3",
    d: "M 817.5,330.5 C 817.167,330.5 816.833,330.5 816.5,330.5C 814.571,326.512 812.904,322.345 811.5,318C 788.493,317.167 765.493,317.334 742.5,318.5C 745.38,324.584 747.38,330.917 748.5,337.5C 744.933,331.272 742.266,324.605 740.5,317.5C 741.025,316.808 741.692,316.308 742.5,316C 765.167,315.333 787.833,315.333 810.5,316C 811.766,316.309 812.933,316.809 814,317.5C 815.282,321.84 816.449,326.173 817.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a7a7",
    d: "M 1020.5,368.5 C 1019.86,366.924 1018.86,365.59 1017.5,364.5C 1017.78,362.585 1017.45,360.919 1016.5,359.5C 1015.94,355.147 1014.6,351.147 1012.5,347.5C 1009.36,338.537 1006.19,329.537 1003,320.5C 1002.58,318.574 1001.41,317.574 999.5,317.5C 976.5,317.5 953.5,317.5 930.5,317.5C 929.357,320.684 928.691,324.017 928.5,327.5C 925.674,331.897 923.674,336.564 922.5,341.5C 921.593,343.657 920.927,345.99 920.5,348.5C 919.833,349.167 919.167,349.833 918.5,350.5C 921.101,340.337 924.268,330.337 928,320.5C 928.814,318.718 929.981,317.218 931.5,316C 954.833,315.333 978.167,315.333 1001.5,316C 1002.42,316.374 1003.25,316.874 1004,317.5C 1010.09,334.344 1015.59,351.344 1020.5,368.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#a2a2a2",
    d: "M 1490.5,316.5 C 1490.5,316.833 1490.5,317.167 1490.5,317.5C 1396.17,317.5 1301.83,317.5 1207.5,317.5C 1206.5,317.5 1205.5,317.5 1204.5,317.5C 1204.5,317.167 1204.5,316.833 1204.5,316.5C 1299.83,315.167 1395.17,315.167 1490.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1a1a1",
    d: "M 1785.5,316.5 C 1787.07,317.687 1788.74,318.687 1790.5,319.5C 1786.85,319.058 1783.18,318.724 1779.5,318.5C 1692.33,317.501 1605,317.167 1517.5,317.5C 1517.17,317.5 1516.83,317.5 1516.5,317.5C 1515.83,317.5 1515.17,317.5 1514.5,317.5C 1514.5,317.167 1514.5,316.833 1514.5,316.5C 1604.69,315.176 1695.02,315.176 1785.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 67.5,317.5 C 153.834,317.333 240.167,317.5 326.5,318C 333.996,319.415 341.329,321.415 348.5,324C 370.179,336.882 384.513,355.382 391.5,379.5C 391.802,382.373 392.469,385.039 393.5,387.5C 393.942,391.154 394.276,394.821 394.5,398.5C 394.426,407.461 394.426,416.794 394.5,426.5C 394.167,429.833 393.833,433.167 393.5,436.5C 393.5,436.833 393.5,437.167 393.5,437.5C 392.542,439.302 391.875,441.302 391.5,443.5C 388.498,455.662 383.165,466.662 375.5,476.5C 370.923,481.345 366.589,486.345 362.5,491.5C 359.326,492.01 356.992,493.677 355.5,496.5C 353.447,496.402 351.78,497.069 350.5,498.5C 347.784,498.386 345.784,499.386 344.5,501.5C 338.8,503.807 332.8,505.307 326.5,506C 289.5,506.667 252.5,506.667 215.5,506C 194.605,485.272 173.938,464.438 153.5,443.5C 208.5,442.833 263.5,442.167 318.5,441.5C 323.988,439.342 327.321,435.342 328.5,429.5C 330.177,425.455 330.844,421.122 330.5,416.5C 330.848,409.094 330.348,401.761 329,394.5C 327.659,389.561 324.826,385.894 320.5,383.5C 320.5,382.833 320.167,382.5 319.5,382.5C 319.389,381.883 319.056,381.383 318.5,381C 287.667,380.833 256.833,380.667 226,380.5C 194.826,380.5 163.993,381.167 133.5,382.5C 133.167,382.5 132.833,382.5 132.5,382.5C 131.883,382.611 131.383,382.944 131,383.5C 130.83,455.237 130.33,526.904 129.5,598.5C 109.167,598.5 88.8333,598.5 68.5,598.5C 67.5026,504.904 67.1693,411.237 67.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212121",
    d: "M 498.5,317.5 C 554.003,317.168 609.336,317.501 664.5,318.5C 610.106,318.179 555.606,318.512 501,319.5C 500.005,318.934 499.172,318.267 498.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M 816.5,330.5 C 816.557,334.029 817.557,337.029 819.5,339.5C 820.167,340.167 820.833,340.833 821.5,341.5C 821.804,344.522 822.304,347.522 823,350.5C 829.731,366.527 835.564,382.86 840.5,399.5C 840.343,400.873 840.51,402.207 841,403.5C 841.737,405.596 842.903,407.263 844.5,408.5C 847.733,420.434 851.733,432.101 856.5,443.5C 856.957,444.298 857.624,444.631 858.5,444.5C 858.337,446.857 858.503,449.19 859,451.5C 863.164,462.495 867.33,473.495 871.5,484.5C 872.478,484.023 873.311,483.357 874,482.5C 875.821,476.883 877.321,471.217 878.5,465.5C 879.167,465.5 879.5,465.167 879.5,464.5C 880.75,464.423 881.583,463.756 882,462.5C 882.494,460.866 882.66,459.199 882.5,457.5C 883.117,457.389 883.617,457.056 884,456.5C 884.495,454.527 884.662,452.527 884.5,450.5C 891.328,432.732 897.661,414.732 903.5,396.5C 908.597,383.178 913.263,369.511 917.5,355.5C 918.75,355.423 919.583,354.756 920,353.5C 920.494,351.866 920.66,350.199 920.5,348.5C 921.117,348.389 921.617,348.056 922,347.5C 922.495,345.527 922.662,343.527 922.5,341.5C 923.674,336.564 925.674,331.897 928.5,327.5C 929.921,324.706 930.921,321.706 931.5,318.5C 954.339,318.831 977.006,318.497 999.5,317.5C 1001.41,317.574 1002.58,318.574 1003,320.5C 1006.19,329.537 1009.36,338.537 1012.5,347.5C 1012.46,350.821 1013.13,353.988 1014.5,357C 1014.68,358.376 1015.35,359.209 1016.5,359.5C 1017.45,360.919 1017.78,362.585 1017.5,364.5C 1018.27,368.998 1019.94,372.998 1022.5,376.5C 1024.92,385.573 1027.92,394.24 1031.5,402.5C 1031.59,404.786 1032.26,406.786 1033.5,408.5C 1034.33,410.752 1034.33,412.919 1033.5,415C 1034.04,415.717 1034.71,416.217 1035.5,416.5C 1039.6,426.884 1043.6,437.217 1047.5,447.5C 1047.83,449.5 1048.17,451.5 1048.5,453.5C 1048.18,456.481 1049.18,458.815 1051.5,460.5C 1052.41,463.276 1053.41,465.943 1054.5,468.5C 1055.1,473.361 1056.27,478.027 1058,482.5C 1059.36,483.38 1060.86,483.714 1062.5,483.5C 1063.32,479.856 1064.15,476.189 1065,472.5C 1069.9,459.396 1074.73,446.396 1079.5,433.5C 1081.26,432.448 1081.92,430.781 1081.5,428.5C 1082.93,425.697 1083.59,422.697 1083.5,419.5C 1084.8,418.013 1085.97,416.346 1087,414.5C 1088.2,409.728 1089.7,405.061 1091.5,400.5C 1093.86,398.077 1094.86,395.077 1094.5,391.5C 1103.92,367.155 1112.92,342.655 1121.5,318C 1144.16,317.5 1166.83,317.333 1189.5,317.5C 1188.83,320.833 1188.17,324.167 1187.5,327.5C 1184.98,329.03 1183.98,331.364 1184.5,334.5C 1183.83,336.833 1183.17,339.167 1182.5,341.5C 1180.76,343.395 1179.76,345.728 1179.5,348.5C 1177.69,349.918 1177.03,351.918 1177.5,354.5C 1175.5,360.135 1173.5,365.801 1171.5,371.5C 1167.65,376.871 1165.32,382.871 1164.5,389.5C 1163.54,392.744 1162.2,395.744 1160.5,398.5C 1158.06,403.912 1156.4,409.578 1155.5,415.5C 1154.32,418.527 1152.99,421.527 1151.5,424.5C 1148.4,430.056 1146.4,436.056 1145.5,442.5C 1143.33,447.673 1141.66,453.007 1140.5,458.5C 1137.26,460.513 1135.93,463.513 1136.5,467.5C 1125.83,497.531 1115.17,527.531 1104.5,557.5C 1102.72,557.926 1101.72,559.092 1101.5,561C 1100.13,564.012 1099.46,567.179 1099.5,570.5C 1098.89,571.391 1098.56,572.391 1098.5,573.5C 1096.18,577.373 1094.84,581.706 1094.5,586.5C 1092.89,589.392 1091.55,592.392 1090.5,595.5C 1089.53,597.139 1088.19,598.473 1086.5,599.5C 1068.86,597.513 1050.86,596.847 1032.5,597.5C 1032.74,596.209 1032.4,595.209 1031.5,594.5C 1027.65,586.169 1024.49,577.502 1022,568.5C 1016.45,552.874 1010.61,537.54 1004.5,522.5C 1004.28,519.565 1003.62,516.731 1002.5,514C 1002.32,512.624 1001.65,511.791 1000.5,511.5C 1000.5,511.167 1000.5,510.833 1000.5,510.5C 1000.51,507.374 999.515,504.707 997.5,502.5C 996.473,498.388 995.139,494.388 993.5,490.5C 993.771,488.62 993.104,487.287 991.5,486.5C 989.553,478.993 987.219,471.66 984.5,464.5C 984.293,461.759 983.293,459.426 981.5,457.5C 978.703,451.408 976.536,445.075 975,438.5C 974.623,437.058 973.79,436.058 972.5,435.5C 971.171,430.185 969.838,424.852 968.5,419.5C 964.575,418.234 962.908,419.901 963.5,424.5C 959.799,435.99 955.799,447.324 951.5,458.5C 949.76,461.08 948.094,463.913 946.5,467C 946.833,467.333 947.167,467.667 947.5,468C 946.418,469.33 945.751,470.83 945.5,472.5C 944.357,475.684 943.691,479.017 943.5,482.5C 942.094,482.973 941.427,483.973 941.5,485.5C 937.274,496.982 933.274,508.649 929.5,520.5C 927.464,522.206 926.464,524.539 926.5,527.5C 917.967,550.94 909.634,574.606 901.5,598.5C 882.603,598.198 863.603,598.531 844.5,599.5C 844.167,598.833 843.833,598.167 843.5,597.5C 842.611,593.569 841.278,589.902 839.5,586.5C 835.977,576.714 832.311,567.047 828.5,557.5C 828.662,555.473 828.495,553.473 828,551.5C 826.942,548.234 825.442,545.234 823.5,542.5C 800.91,479.9 778.41,417.233 756,354.5C 753.982,348.478 751.482,342.811 748.5,337.5C 747.38,330.917 745.38,324.584 742.5,318.5C 765.493,317.334 788.493,317.167 811.5,318C 812.904,322.345 814.571,326.512 816.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222222",
    d: "M 999.5,317.5 C 977.006,318.497 954.339,318.831 931.5,318.5C 930.921,321.706 929.921,324.706 928.5,327.5C 928.691,324.017 929.357,320.684 930.5,317.5C 953.5,317.5 976.5,317.5 999.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 1207.5,317.5 C 1301.83,317.5 1396.17,317.5 1490.5,317.5C 1490.24,339.147 1490.24,360.814 1490.5,382.5C 1416.83,381.836 1343.49,382.503 1270.5,384.5C 1270.5,398.167 1270.5,411.833 1270.5,425.5C 1270.61,426.117 1270.94,426.617 1271.5,427C 1339.5,427.5 1407.5,427.667 1475.5,427.5C 1475.5,427.833 1475.5,428.167 1475.5,428.5C 1474.73,429.172 1474.07,430.005 1473.5,431C 1474.05,450.558 1474.39,470.391 1474.5,490.5C 1406.66,490.167 1339,490.501 1271.5,491.5C 1270.17,505.5 1270.17,519.5 1271.5,533.5C 1344,534.499 1416.66,534.833 1489.5,534.5C 1489.8,556.2 1489.47,577.866 1488.5,599.5C 1394.07,598.836 1299.74,598.169 1205.5,597.5C 1204.84,503.955 1205.51,410.621 1207.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#cbcbcb",
    d: "M 1514.5,316.5 C 1514.5,316.833 1514.5,317.167 1514.5,317.5C 1513.88,317.611 1513.38,317.944 1513,318.5C 1512.33,411.833 1512.33,505.167 1513,598.5C 1513.38,599.056 1513.88,599.389 1514.5,599.5C 1535.9,600.831 1557.4,600.831 1579,599.5C 1579.5,527.834 1579.67,456.167 1579.5,384.5C 1579.83,384.5 1580.17,384.5 1580.5,384.5C 1580.67,456.501 1580.5,528.501 1580,600.5C 1557.91,601.66 1535.74,601.827 1513.5,601C 1513,600.5 1512.5,600 1512,599.5C 1511.33,505.5 1511.33,411.5 1512,317.5C 1512.67,316.748 1513.5,316.414 1514.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 1514.5,317.5 C 1515.17,317.5 1515.83,317.5 1516.5,317.5C 1515.5,411.096 1515.17,504.763 1515.5,598.5C 1514.5,505.001 1514.17,411.335 1514.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 1516.5,317.5 C 1516.83,317.5 1517.17,317.5 1517.5,317.5C 1604.24,318.168 1691.07,318.835 1778,319.5C 1778.38,318.944 1778.88,318.611 1779.5,318.5C 1783.18,318.724 1786.85,319.058 1790.5,319.5C 1791.17,319.5 1791.83,319.5 1792.5,319.5C 1792.95,320.458 1793.62,321.292 1794.5,322C 1797.25,322.272 1799.92,322.772 1802.5,323.5C 1805.48,324.654 1808.48,325.82 1811.5,327C 1816.16,331.324 1821.16,335.158 1826.5,338.5C 1828.09,341.764 1830.43,344.431 1833.5,346.5C 1835.45,350.059 1837.11,353.725 1838.5,357.5C 1841.43,363.877 1844.43,370.544 1847.5,377.5C 1849.51,384.858 1851.17,392.191 1852.5,399.5C 1852.5,402.5 1852.5,405.5 1852.5,408.5C 1852.23,413.333 1852.23,418.333 1852.5,423.5C 1852.5,423.833 1852.5,424.167 1852.5,424.5C 1851.58,430.051 1850.58,435.718 1849.5,441.5C 1846.96,449.506 1844.29,457.506 1841.5,465.5C 1841.5,465.833 1841.5,466.167 1841.5,466.5C 1840.5,466.414 1839.67,466.748 1839,467.5C 1829.27,484.409 1815.44,496.409 1797.5,503.5C 1794.3,502.964 1791.64,503.631 1789.5,505.5C 1775.83,506.167 1762.17,506.833 1748.5,507.5C 1749.41,510.747 1751.41,513.08 1754.5,514.5C 1754.83,515.5 1755.5,516.167 1756.5,516.5C 1757.75,519.093 1759.42,521.427 1761.5,523.5C 1762.47,526.135 1764.14,528.135 1766.5,529.5C 1769.09,531.814 1771.75,534.147 1774.5,536.5C 1776.77,540.436 1779.77,543.769 1783.5,546.5C 1784.34,548.853 1785.67,550.853 1787.5,552.5C 1787.39,553.117 1787.06,553.617 1786.5,554C 1788.32,554.997 1789.99,556.164 1791.5,557.5C 1793.17,558.5 1794.5,559.833 1795.5,561.5C 1797.82,565.482 1800.82,568.815 1804.5,571.5C 1806.46,573.156 1808.46,574.823 1810.5,576.5C 1812.79,580.456 1815.79,583.789 1819.5,586.5C 1820.78,589.112 1822.45,591.445 1824.5,593.5C 1824.7,595.044 1825.37,596.378 1826.5,597.5C 1826.04,598.298 1825.38,598.631 1824.5,598.5C 1796.34,597.502 1768,597.169 1739.5,597.5C 1738.83,596.833 1738.17,596.167 1737.5,595.5C 1734.79,593.115 1732.12,590.782 1729.5,588.5C 1729.29,587.078 1728.79,585.745 1728,584.5C 1719.63,575.797 1711.63,566.797 1704,557.5C 1702.73,556.117 1701.23,555.117 1699.5,554.5C 1695.17,549.329 1691,543.995 1687,538.5C 1680.52,532.17 1674.52,525.503 1669,518.5C 1668.18,517.177 1667.02,516.511 1665.5,516.5C 1658.76,508.052 1651.76,499.719 1644.5,491.5C 1642.44,489.758 1640.44,488.091 1638.5,486.5C 1637.25,484.068 1635.75,481.734 1634,479.5C 1630.63,475.963 1627.13,472.629 1623.5,469.5C 1616.48,460.49 1609.15,451.823 1601.5,443.5C 1658.5,442.833 1715.5,442.167 1772.5,441.5C 1780.11,439.231 1784.44,434.231 1785.5,426.5C 1786.27,425.737 1786.77,424.737 1787,423.5C 1787.67,415.833 1787.67,408.167 1787,400.5C 1786.77,399.263 1786.27,398.263 1785.5,397.5C 1784.62,389.621 1780.29,384.955 1772.5,383.5C 1740.5,382.833 1708.34,382.5 1676,382.5C 1643.49,382.5 1611.33,383.167 1579.5,384.5C 1578.67,455.665 1578.17,526.999 1578,598.5C 1557.63,598.179 1537.13,598.513 1516.5,599.5C 1516.5,598.833 1516.17,598.5 1515.5,598.5C 1515.17,504.763 1515.5,411.096 1516.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 1517.5,317.5 C 1605,317.167 1692.33,317.501 1779.5,318.5C 1778.88,318.611 1778.38,318.944 1778,319.5C 1691.07,318.835 1604.24,318.168 1517.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 497.5,317.5 C 492.342,318.818 487.009,319.818 481.5,320.5C 481.833,319.833 482.167,319.167 482.5,318.5C 483.5,318.5 484.5,318.5 485.5,318.5C 489.466,317.838 493.466,317.505 497.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M 497.5,317.5 C 497.833,317.5 498.167,317.5 498.5,317.5C 499.172,318.267 500.005,318.934 501,319.5C 555.606,318.512 610.106,318.179 664.5,318.5C 666.167,318.5 667.833,318.5 669.5,318.5C 672.61,319.088 675.61,319.755 678.5,320.5C 683.255,322.358 688.255,323.691 693.5,324.5C 696.808,325.888 700.141,327.388 703.5,329C 708.457,333.133 713.79,336.633 719.5,339.5C 719.894,341.71 721.227,343.043 723.5,343.5C 723.833,344.5 724.5,345.167 725.5,345.5C 728.182,349.507 731.182,353.173 734.5,356.5C 735.043,359.038 736.043,361.372 737.5,363.5C 736.342,364.95 736.842,365.95 739,366.5C 740.096,370.605 741.929,374.272 744.5,377.5C 744.41,380.152 745.076,382.485 746.5,384.5C 746.344,388.582 746.844,392.582 748,396.5C 748.5,436.165 748.667,475.832 748.5,515.5C 746.467,524.05 744.8,532.717 743.5,541.5C 740.677,547.996 737.677,554.329 734.5,560.5C 729.822,565.179 725.489,570.179 721.5,575.5C 715.122,579.031 709.122,583.198 703.5,588C 695.304,592.117 686.637,595.117 677.5,597C 676.944,597.383 676.611,597.883 676.5,598.5C 673.167,598.5 669.833,598.5 666.5,598.5C 607.832,598.667 549.166,598.5 490.5,598C 482.422,596.352 474.422,594.519 466.5,592.5C 464.572,590.706 462.238,589.706 459.5,589.5C 458.198,587.178 456.198,585.845 453.5,585.5C 453.027,584.094 452.027,583.427 450.5,583.5C 442.633,576.463 435.133,568.797 428,560.5C 422.478,551.403 418.311,541.736 415.5,531.5C 415.354,527.613 414.687,523.946 413.5,520.5C 413.5,519.833 413.5,519.167 413.5,518.5C 413.5,477.833 413.5,437.167 413.5,396.5C 414.475,393.689 415.142,390.689 415.5,387.5C 415.421,384.729 415.921,382.063 417,379.5C 419.28,373.019 421.78,366.685 424.5,360.5C 429.182,355.481 433.515,350.148 437.5,344.5C 444.341,339.165 451.341,333.998 458.5,329C 465.899,325.478 473.566,322.644 481.5,320.5C 487.009,319.818 492.342,318.818 497.5,317.5 Z M 499.5,384.5 C 554.834,384.333 610.168,384.5 665.5,385C 673.522,386.764 678.689,391.598 681,399.5C 681.5,437.832 681.667,476.165 681.5,514.5C 681.5,515.5 681.5,516.5 681.5,517.5C 679.707,519.426 678.707,521.759 678.5,524.5C 676.866,525.207 675.532,526.373 674.5,528C 670.775,529.563 667.108,531.063 663.5,532.5C 608.499,532.667 553.499,532.5 498.5,532C 496.323,530.798 493.989,530.298 491.5,530.5C 488.872,528.512 486.205,526.512 483.5,524.5C 482.019,520.675 481.185,516.675 481,512.5C 480.333,476.5 480.333,440.5 481,404.5C 481.185,400.325 482.019,396.325 483.5,392.5C 488.045,388.228 493.378,385.561 499.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212121",
    d: "M 1204.5,317.5 C 1205.5,317.5 1206.5,317.5 1207.5,317.5C 1205.51,410.621 1204.84,503.955 1205.5,597.5C 1204.5,504.335 1204.17,411.001 1204.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616161",
    d: "M 1514.5,317.5 C 1514.17,411.335 1514.5,505.001 1515.5,598.5C 1516.17,598.5 1516.5,598.833 1516.5,599.5C 1515.83,599.5 1515.17,599.5 1514.5,599.5C 1513.88,599.389 1513.38,599.056 1513,598.5C 1512.33,505.167 1512.33,411.833 1513,318.5C 1513.38,317.944 1513.88,317.611 1514.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#c1c1c1",
    d: "M 1785.5,316.5 C 1791.55,317.433 1797.21,319.1 1802.5,321.5C 1799.03,321.453 1795.7,320.787 1792.5,319.5C 1791.83,319.5 1791.17,319.5 1790.5,319.5C 1788.74,318.687 1787.07,317.687 1785.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 67.5,317.5 C 67.1693,411.237 67.5026,504.904 68.5,598.5C 67.8333,598.5 67.1667,598.5 66.5,598.5C 66.1673,504.665 66.5006,410.999 67.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M 678.5,320.5 C 683.915,320.736 688.915,322.069 693.5,324.5C 688.255,323.691 683.255,322.358 678.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3c3c",
    d: "M 1792.5,319.5 C 1795.7,320.787 1799.03,321.453 1802.5,321.5C 1802.5,322.167 1802.5,322.833 1802.5,323.5C 1799.92,322.772 1797.25,322.272 1794.5,322C 1793.62,321.292 1792.95,320.458 1792.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a6a6a6",
    d: "M 666.5,316.5 C 681.589,317.682 695.589,322.182 708.5,330C 712.359,333.032 716.026,336.198 719.5,339.5C 713.79,336.633 708.457,333.133 703.5,329C 700.141,327.388 696.808,325.888 693.5,324.5C 688.915,322.069 683.915,320.736 678.5,320.5C 675.61,319.755 672.61,319.088 669.5,318.5C 668.5,317.833 667.5,317.167 666.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#9e9e9e",
    d: "M 482.5,318.5 C 482.167,319.167 481.833,319.833 481.5,320.5C 473.566,322.644 465.899,325.478 458.5,329C 451.341,333.998 444.341,339.165 437.5,344.5C 449.568,330.96 464.568,322.293 482.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a2a2a2",
    d: "M 1802.5,321.5 C 1812.18,324.857 1820.18,330.524 1826.5,338.5C 1821.16,335.158 1816.16,331.324 1811.5,327C 1808.48,325.82 1805.48,324.654 1802.5,323.5C 1802.5,322.833 1802.5,322.167 1802.5,321.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b3b3b",
    d: "M 816.5,330.5 C 816.833,330.5 817.167,330.5 817.5,330.5C 818.167,333.5 818.833,336.5 819.5,339.5C 817.557,337.029 816.557,334.029 816.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b5b5b5",
    d: "M 817.5,330.5 C 818.117,330.611 818.617,330.944 819,331.5C 819.661,334.946 820.495,338.279 821.5,341.5C 820.833,340.833 820.167,340.167 819.5,339.5C 818.833,336.5 818.167,333.5 817.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2a2a2",
    d: "M 719.5,339.5 C 721.341,340.402 722.674,341.736 723.5,343.5C 721.227,343.043 719.894,341.71 719.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a7a7a7",
    d: "M 1826.5,338.5 C 1829.57,340.569 1831.91,343.236 1833.5,346.5C 1830.43,344.431 1828.09,341.764 1826.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7d7d",
    d: "M 1182.5,341.5 C 1182.5,342.167 1182.5,342.833 1182.5,343.5C 1182.17,344.833 1181.83,346.167 1181.5,347.5C 1180.83,347.833 1180.17,348.167 1179.5,348.5C 1179.76,345.728 1180.76,343.395 1182.5,341.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#c5c5c5",
    d: "M 723.5,343.5 C 724.833,343.5 725.5,344.167 725.5,345.5C 724.5,345.167 723.833,344.5 723.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a4a4a4",
    d: "M 1182.5,343.5 C 1182.5,342.833 1182.5,342.167 1182.5,341.5C 1183.17,339.167 1183.83,336.833 1184.5,334.5C 1185.74,332.351 1186.74,330.018 1187.5,327.5C 1188.17,324.167 1188.83,320.833 1189.5,317.5C 1166.83,317.333 1144.16,317.5 1121.5,318C 1112.92,342.655 1103.92,367.155 1094.5,391.5C 1093.83,392.5 1093.17,393.5 1092.5,394.5C 1100.54,369.998 1109.04,345.665 1118,321.5C 1118.98,319.552 1120.15,317.718 1121.5,316C 1145.2,315.197 1168.86,315.363 1192.5,316.5C 1189.92,325.866 1186.58,334.866 1182.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b3b3b",
    d: "M 1187.5,327.5 C 1186.74,330.018 1185.74,332.351 1184.5,334.5C 1183.98,331.364 1184.98,329.03 1187.5,327.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383838",
    d: "M 922.5,341.5 C 922.662,343.527 922.495,345.527 922,347.5C 921.617,348.056 921.117,348.389 920.5,348.5C 920.927,345.99 921.593,343.657 922.5,341.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#878787",
    d: "M 67.5,317.5 C 153.998,316.501 240.665,316.167 327.5,316.5C 329.905,317.768 332.572,318.435 335.5,318.5C 350.913,321.976 363.746,329.976 374,342.5C 381.931,352.361 387.764,363.361 391.5,375.5C 391.5,376.833 391.5,378.167 391.5,379.5C 384.513,355.382 370.179,336.882 348.5,324C 341.329,321.415 333.996,319.415 326.5,318C 240.167,317.5 153.834,317.333 67.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#acacac",
    d: "M 725.5,345.5 C 729.592,348.26 732.592,351.927 734.5,356.5C 731.182,353.173 728.182,349.507 725.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#373737",
    d: "M 1179.5,348.5 C 1179.12,350.698 1178.46,352.698 1177.5,354.5C 1177.03,351.918 1177.69,349.918 1179.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#393939",
    d: "M 1012.5,347.5 C 1014.6,351.147 1015.94,355.147 1016.5,359.5C 1015.35,359.209 1014.68,358.376 1014.5,357C 1013.13,353.988 1012.46,350.821 1012.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#aeaeae",
    d: "M 1833.5,346.5 C 1836.66,350.148 1839.33,354.148 1841.5,358.5C 1840.61,357.89 1839.61,357.557 1838.5,357.5C 1837.11,353.725 1835.45,350.059 1833.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383838",
    d: "M 920.5,348.5 C 920.66,350.199 920.494,351.866 920,353.5C 919.583,354.756 918.75,355.423 917.5,355.5C 918.234,354.292 918.567,352.959 918.5,351.5C 918.5,351.167 918.5,350.833 918.5,350.5C 919.167,349.833 919.833,349.167 920.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#afafaf",
    d: "M 437.5,344.5 C 433.515,350.148 429.182,355.481 424.5,360.5C 427.379,353.957 431.712,348.624 437.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#9f9f9f",
    d: "M 734.5,356.5 C 737.241,358.975 739.241,361.975 740.5,365.5C 739.5,364.833 738.5,364.167 737.5,363.5C 736.043,361.372 735.043,359.038 734.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#cacaca",
    d: "M 1841.5,358.5 C 1842.67,359.514 1843.34,360.847 1843.5,362.5C 1841.9,361.713 1841.23,360.38 1841.5,358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#c2c2c2",
    d: "M 1843.5,362.5 C 1844.34,363.671 1845.01,365.005 1845.5,366.5C 1843.82,365.817 1843.16,364.483 1843.5,362.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#b0b0b0",
    d: "M 1181.5,347.5 C 1178.84,356.819 1175.5,365.819 1171.5,374.5C 1171.5,373.5 1171.5,372.5 1171.5,371.5C 1173.5,365.801 1175.5,360.135 1177.5,354.5C 1178.46,352.698 1179.12,350.698 1179.5,348.5C 1180.17,348.167 1180.83,347.833 1181.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#373737",
    d: "M 1838.5,357.5 C 1839.61,357.557 1840.61,357.89 1841.5,358.5C 1841.23,360.38 1841.9,361.713 1843.5,362.5C 1843.16,364.483 1843.82,365.817 1845.5,366.5C 1845.87,370.233 1846.54,373.899 1847.5,377.5C 1844.43,370.544 1841.43,363.877 1838.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f3f3f",
    d: "M 737.5,363.5 C 738.5,364.167 739.5,364.833 740.5,365.5C 740.182,368.481 741.182,370.815 743.5,372.5C 744.038,374.117 744.371,375.784 744.5,377.5C 741.929,374.272 740.096,370.605 739,366.5C 736.842,365.95 736.342,364.95 737.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#c2c2c2",
    d: "M 740.5,365.5 C 742.294,367.428 743.294,369.762 743.5,372.5C 741.182,370.815 740.182,368.481 740.5,365.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#afafaf",
    d: "M 1845.5,366.5 C 1847.66,370.903 1849.33,375.569 1850.5,380.5C 1849.73,379.306 1848.73,378.306 1847.5,377.5C 1846.54,373.899 1845.87,370.233 1845.5,366.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363636",
    d: "M 1017.5,364.5 C 1018.86,365.59 1019.86,366.924 1020.5,368.5C 1021.17,371.167 1021.83,373.833 1022.5,376.5C 1019.94,372.998 1018.27,368.998 1017.5,364.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#aeaeae",
    d: "M 424.5,360.5 C 421.78,366.685 419.28,373.019 417,379.5C 415.921,382.063 415.421,384.729 415.5,387.5C 414.883,387.611 414.383,387.944 414,388.5C 413.503,391.146 413.336,393.813 413.5,396.5C 413.5,437.167 413.5,477.833 413.5,518.5C 413.167,518.5 412.833,518.5 412.5,518.5C 411.062,474.524 411.229,430.524 413,386.5C 415.343,377.042 419.177,368.375 424.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363636",
    d: "M 1171.5,371.5 C 1171.5,372.5 1171.5,373.5 1171.5,374.5C 1168.72,379.319 1166.38,384.319 1164.5,389.5C 1165.32,382.871 1167.65,376.871 1171.5,371.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a3a3a3",
    d: "M 821.5,341.5 C 826.376,354.9 831.543,368.234 837,381.5C 839.936,389.665 842.436,397.999 844.5,406.5C 843.433,404.036 842.1,401.703 840.5,399.5C 835.564,382.86 829.731,366.527 823,350.5C 822.304,347.522 821.804,344.522 821.5,341.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999999",
    d: "M 918.5,351.5 C 918.567,352.959 918.234,354.292 917.5,355.5C 913.263,369.511 908.597,383.178 903.5,396.5C 903.517,394.435 903.85,392.435 904.5,390.5C 906.995,382.174 909.495,373.841 912,365.5C 913.942,360.623 916.108,355.956 918.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a8a8a8",
    d: "M 743.5,372.5 C 744.117,372.611 744.617,372.944 745,373.5C 745.852,377.189 746.685,380.856 747.5,384.5C 747.167,384.5 746.833,384.5 746.5,384.5C 745.076,382.485 744.41,380.152 744.5,377.5C 744.371,375.784 744.038,374.117 743.5,372.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M 319.5,382.5 C 257.5,382.5 195.5,382.5 133.5,382.5C 163.993,381.167 194.826,380.5 226,380.5C 256.833,380.667 287.667,380.833 318.5,381C 319.056,381.383 319.389,381.883 319.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#cdcdcd",
    d: "M 391.5,375.5 C 393.966,379.018 394.966,383.018 394.5,387.5C 394.167,387.5 393.833,387.5 393.5,387.5C 393.889,384.447 393.223,381.78 391.5,379.5C 391.5,378.167 391.5,376.833 391.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a4a4a4",
    d: "M 1020.5,368.5 C 1022.44,371.197 1023.94,374.197 1025,377.5C 1027.94,385.665 1030.44,393.999 1032.5,402.5C 1032.17,402.5 1031.83,402.5 1031.5,402.5C 1027.92,394.24 1024.92,385.573 1022.5,376.5C 1021.83,373.833 1021.17,371.167 1020.5,368.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212121",
    d: "M 132.5,382.5 C 132.5,454.167 132.5,525.833 132.5,597.5C 131.791,598.404 130.791,598.737 129.5,598.5C 130.33,526.904 130.83,455.237 131,383.5C 131.383,382.944 131.883,382.611 132.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 1490.5,317.5 C 1491.5,339.327 1491.83,361.327 1491.5,383.5C 1418,383.167 1344.66,383.501 1271.5,384.5C 1271.17,384.5 1270.83,384.5 1270.5,384.5C 1343.49,382.503 1416.83,381.836 1490.5,382.5C 1490.24,360.814 1490.24,339.147 1490.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 1772.5,383.5 C 1708.33,383.168 1644.33,383.501 1580.5,384.5C 1580.17,384.5 1579.83,384.5 1579.5,384.5C 1611.33,383.167 1643.49,382.5 1676,382.5C 1708.34,382.5 1740.5,382.833 1772.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b7b7b7",
    d: "M 1490.5,317.5 C 1490.5,317.167 1490.5,316.833 1490.5,316.5C 1492.49,338.809 1493.16,361.475 1492.5,384.5C 1418.83,384.5 1345.17,384.5 1271.5,384.5C 1344.66,383.501 1418,383.167 1491.5,383.5C 1491.83,361.327 1491.5,339.327 1490.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M 132.5,382.5 C 132.833,382.5 133.167,382.5 133.5,382.5C 195.5,382.5 257.5,382.5 319.5,382.5C 320.167,382.5 320.5,382.833 320.5,383.5C 258.167,383.5 195.833,383.5 133.5,383.5C 133.833,455.002 133.499,526.335 132.5,597.5C 132.5,525.833 132.5,454.167 132.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d0d0d0",
    d: "M 320.5,383.5 C 320.5,383.833 320.5,384.167 320.5,384.5C 258.5,384.5 196.5,384.5 134.5,384.5C 134.667,455.834 134.5,527.167 134,598.5C 111.402,599.831 88.9023,599.831 66.5,598.5C 67.1667,598.5 67.8333,598.5 68.5,598.5C 88.8333,598.5 109.167,598.5 129.5,598.5C 130.791,598.737 131.791,598.404 132.5,597.5C 133.499,526.335 133.833,455.002 133.5,383.5C 195.833,383.5 258.167,383.5 320.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#636363",
    d: "M 391.5,379.5 C 393.223,381.78 393.889,384.447 393.5,387.5C 392.469,385.039 391.802,382.373 391.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 499.5,383.5 C 499.5,383.833 499.5,384.167 499.5,384.5C 493.378,385.561 488.045,388.228 483.5,392.5C 483.167,392.5 482.833,392.5 482.5,392.5C 483.706,389.702 485.706,387.535 488.5,386C 491.876,384.101 495.543,383.268 499.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#686868",
    d: "M 393.5,387.5 C 393.833,387.5 394.167,387.5 394.5,387.5C 395.114,391.135 395.448,394.802 395.5,398.5C 395.167,398.5 394.833,398.5 394.5,398.5C 394.276,394.821 393.942,391.154 393.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707070",
    d: "M 1847.5,377.5 C 1848.73,378.306 1849.73,379.306 1850.5,380.5C 1851.34,382.379 1851.67,384.379 1851.5,386.5C 1852.2,390.798 1852.53,395.131 1852.5,399.5C 1851.17,392.191 1849.51,384.858 1847.5,377.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#a4a4a4",
    d: "M 748.5,337.5 C 751.482,342.811 753.982,348.478 756,354.5C 778.41,417.233 800.91,479.9 823.5,542.5C 824.729,547.796 826.396,552.796 828.5,557.5C 832.311,567.047 835.977,576.714 839.5,586.5C 839.993,588.806 840.326,591.139 840.5,593.5C 838.558,590.766 837.058,587.766 836,584.5C 809.286,507.744 781.619,431.077 753,354.5C 751.18,348.891 749.68,343.224 748.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 415.5,387.5 C 415.142,390.689 414.475,393.689 413.5,396.5C 413.336,393.813 413.503,391.146 414,388.5C 414.383,387.944 414.883,387.611 415.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#c0c0c0",
    d: "M 747.5,386.5 C 749.265,389.123 749.932,392.123 749.5,395.5C 748.525,392.689 747.858,389.689 747.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#cbcbcb",
    d: "M 904.5,390.5 C 903.85,392.435 903.517,394.435 903.5,396.5C 903.167,396.5 902.833,396.5 902.5,396.5C 902.054,393.99 902.72,391.99 904.5,390.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a2a2a2",
    d: "M 320.5,384.5 C 320.5,384.167 320.5,383.833 320.5,383.5C 324.826,385.894 327.659,389.561 329,394.5C 330.348,401.761 330.848,409.094 330.5,416.5C 330.167,416.5 329.833,416.5 329.5,416.5C 328.735,408.837 327.902,401.17 327,393.5C 325.778,389.784 323.612,386.784 320.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595959",
    d: "M 1094.5,391.5 C 1094.86,395.077 1093.86,398.077 1091.5,400.5C 1091.52,398.435 1091.85,396.435 1092.5,394.5C 1093.17,393.5 1093.83,392.5 1094.5,391.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 394.5,398.5 C 394.833,398.5 395.167,398.5 395.5,398.5C 395.5,407.833 395.5,417.167 395.5,426.5C 395.167,426.5 394.833,426.5 394.5,426.5C 394.426,416.794 394.426,407.461 394.5,398.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 478.5,399.5 C 478.5,438.833 478.5,478.167 478.5,517.5C 477.784,515.444 477.117,513.277 476.5,511C 476.5,476.333 476.5,441.667 476.5,407C 477.123,404.393 477.79,401.893 478.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.908
    },
    fill: "#a9a9a9",
    d: "M 394.5,387.5 C 395.222,387.918 395.722,388.584 396,389.5C 397.965,404.832 397.965,420.165 396,435.5C 395.617,436.056 395.117,436.389 394.5,436.5C 395.207,433.214 395.54,429.881 395.5,426.5C 395.5,417.167 395.5,407.833 395.5,398.5C 395.448,394.802 395.114,391.135 394.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#a4a4a4",
    d: "M 682.5,401.5 C 682.832,439.337 682.498,477.004 681.5,514.5C 681.667,476.165 681.5,437.832 681,399.5C 678.689,391.598 673.522,386.764 665.5,385C 610.168,384.5 554.834,384.333 499.5,384.5C 499.5,384.167 499.5,383.833 499.5,383.5C 553.429,382.338 607.429,382.171 661.5,383C 670.904,383.693 677.737,388.193 682,396.5C 682.494,398.134 682.66,399.801 682.5,401.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3c3c",
    d: "M 840.5,399.5 C 842.1,401.703 843.433,404.036 844.5,406.5C 844.5,407.167 844.5,407.833 844.5,408.5C 842.903,407.263 841.737,405.596 841,403.5C 840.51,402.207 840.343,400.873 840.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a9a9a9",
    d: "M 1092.5,394.5 C 1091.85,396.435 1091.52,398.435 1091.5,400.5C 1089.7,405.061 1088.2,409.728 1087,414.5C 1085.97,416.346 1084.8,418.013 1083.5,419.5C 1085.82,411.382 1088.32,403.382 1091,395.5C 1091.38,394.944 1091.88,394.611 1092.5,394.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878787",
    d: "M 480.5,396.5 C 479.167,437.833 479.167,479.167 480.5,520.5C 479.833,519.5 479.167,518.5 478.5,517.5C 478.5,478.167 478.5,438.833 478.5,399.5C 479.167,398.5 479.833,397.5 480.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#636363",
    d: "M 682.5,401.5 C 683.664,439.331 683.831,477.331 683,515.5C 682.667,517.833 682.333,520.167 682,522.5C 681.617,523.056 681.117,523.389 680.5,523.5C 681.15,521.565 681.483,519.565 681.5,517.5C 681.5,516.5 681.5,515.5 681.5,514.5C 682.498,477.004 682.832,439.337 682.5,401.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M 746.5,384.5 C 746.833,384.5 747.167,384.5 747.5,384.5C 747.5,385.167 747.5,385.833 747.5,386.5C 747.858,389.689 748.525,392.689 749.5,395.5C 750.83,437.598 750.83,479.598 749.5,521.5C 748.833,522.5 748.167,523.5 747.5,524.5C 747.704,521.482 748.037,518.482 748.5,515.5C 748.667,475.832 748.5,436.165 748,396.5C 746.844,392.582 746.344,388.582 746.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#cbcbcb",
    d: "M 1032.5,402.5 C 1034.28,403.99 1034.95,405.99 1034.5,408.5C 1034.17,408.5 1033.83,408.5 1033.5,408.5C 1033.48,406.435 1033.15,404.435 1032.5,402.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b7b7b7",
    d: "M 482.5,392.5 C 482.833,392.5 483.167,392.5 483.5,392.5C 482.019,396.325 481.185,400.325 481,404.5C 480.333,440.5 480.333,476.5 481,512.5C 481.185,516.675 482.019,520.675 483.5,524.5C 482.833,524.167 482.167,523.833 481.5,523.5C 480.89,522.609 480.557,521.609 480.5,520.5C 479.167,479.167 479.167,437.833 480.5,396.5C 480.66,394.847 481.326,393.514 482.5,392.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727272",
    d: "M 1031.5,402.5 C 1031.83,402.5 1032.17,402.5 1032.5,402.5C 1033.15,404.435 1033.48,406.435 1033.5,408.5C 1032.26,406.786 1031.59,404.786 1031.5,402.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7a7a",
    d: "M 1785.5,397.5 C 1786.27,398.263 1786.77,399.263 1787,400.5C 1787.67,408.167 1787.67,415.833 1787,423.5C 1786.77,424.737 1786.27,425.737 1785.5,426.5C 1786.83,416.833 1786.83,407.167 1785.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdbdbd",
    d: "M 1851.5,386.5 C 1852.22,386.918 1852.72,387.584 1853,388.5C 1853.48,396.378 1854.31,404.212 1855.5,412C 1854.5,419.813 1853.67,427.646 1853,435.5C 1852.77,436.737 1852.27,437.737 1851.5,438.5C 1852.23,433.87 1852.56,429.203 1852.5,424.5C 1852.5,424.167 1852.5,423.833 1852.5,423.5C 1853.83,418.5 1853.83,413.5 1852.5,408.5C 1852.5,405.5 1852.5,402.5 1852.5,399.5C 1852.53,395.131 1852.2,390.798 1851.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e2e2e",
    d: "M 1160.5,398.5 C 1159.58,404.528 1157.92,410.195 1155.5,415.5C 1156.4,409.578 1158.06,403.912 1160.5,398.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a3a3a",
    d: "M 1033.5,408.5 C 1033.83,408.5 1034.17,408.5 1034.5,408.5C 1035.27,411.096 1035.6,413.763 1035.5,416.5C 1034.71,416.217 1034.04,415.717 1033.5,415C 1034.33,412.919 1034.33,410.752 1033.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7d7d",
    d: "M 1852.5,408.5 C 1853.83,413.5 1853.83,418.5 1852.5,423.5C 1852.23,418.333 1852.23,413.333 1852.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#797979",
    d: "M 329.5,416.5 C 329.833,416.5 330.167,416.5 330.5,416.5C 330.844,421.122 330.177,425.455 328.5,429.5C 329.08,425.19 329.414,420.857 329.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 844.5,406.5 C 845.957,408.242 847.124,410.242 848,412.5C 851.202,423.273 854.702,433.94 858.5,444.5C 857.624,444.631 856.957,444.298 856.5,443.5C 851.733,432.101 847.733,420.434 844.5,408.5C 844.5,407.833 844.5,407.167 844.5,406.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f3f3f",
    d: "M 968.5,419.5 C 965.703,419.967 964.369,421.633 964.5,424.5C 964.167,424.5 963.833,424.5 963.5,424.5C 962.908,419.901 964.575,418.234 968.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8c8c",
    d: "M 1034.5,408.5 C 1035.12,408.611 1035.62,408.944 1036,409.5C 1038.69,418.26 1041.69,426.926 1045,435.5C 1046.15,439.453 1046.98,443.453 1047.5,447.5C 1043.6,437.217 1039.6,426.884 1035.5,416.5C 1035.6,413.763 1035.27,411.096 1034.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#b4b4b4",
    d: "M 1083.5,419.5 C 1083.59,422.697 1082.93,425.697 1081.5,428.5C 1080.83,429.167 1080.17,429.833 1079.5,430.5C 1080.02,427.11 1080.86,423.777 1082,420.5C 1082.38,419.944 1082.88,419.611 1083.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdbdbd",
    d: "M 1270.5,384.5 C 1270.83,384.5 1271.17,384.5 1271.5,384.5C 1271.17,397.85 1271.5,411.183 1272.5,424.5C 1306.29,423.837 1340.13,423.503 1374,423.5C 1408.25,423.34 1442.42,423.84 1476.5,425C 1477.83,447.264 1477.83,469.431 1476.5,491.5C 1476.83,469.66 1476.5,447.994 1475.5,426.5C 1407.24,425.504 1338.9,425.17 1270.5,425.5C 1270.5,411.833 1270.5,398.167 1270.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b0b0b0",
    d: "M 968.5,419.5 C 969.838,424.852 971.171,430.185 972.5,435.5C 970.187,431.07 968.354,426.403 967,421.5C 966.148,422.571 965.315,423.571 964.5,424.5C 964.369,421.633 965.703,419.967 968.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M 1270.5,425.5 C 1338.9,425.17 1407.24,425.504 1475.5,426.5C 1475.5,426.833 1475.5,427.167 1475.5,427.5C 1407.5,427.667 1339.5,427.5 1271.5,427C 1270.94,426.617 1270.61,426.117 1270.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707070",
    d: "M 1475.5,426.5 C 1476.5,447.994 1476.83,469.66 1476.5,491.5C 1408.17,491.5 1339.83,491.5 1271.5,491.5C 1339,490.501 1406.66,490.167 1474.5,490.5C 1475.5,470.007 1475.83,449.34 1475.5,428.5C 1475.5,428.167 1475.5,427.833 1475.5,427.5C 1475.5,427.167 1475.5,426.833 1475.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6a6a",
    d: "M 394.5,426.5 C 394.833,426.5 395.167,426.5 395.5,426.5C 395.54,429.881 395.207,433.214 394.5,436.5C 394.167,436.5 393.833,436.5 393.5,436.5C 393.833,433.167 394.167,429.833 394.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 1475.5,428.5 C 1475.83,449.34 1475.5,470.007 1474.5,490.5C 1474.39,470.391 1474.05,450.558 1473.5,431C 1474.07,430.005 1474.73,429.172 1475.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383838",
    d: "M 1081.5,428.5 C 1081.92,430.781 1081.26,432.448 1079.5,433.5C 1079.5,432.5 1079.5,431.5 1079.5,430.5C 1080.17,429.833 1080.83,429.167 1081.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M 1151.5,424.5 C 1149.9,430.126 1148.4,435.793 1147,441.5C 1146.62,442.056 1146.12,442.389 1145.5,442.5C 1146.4,436.056 1148.4,430.056 1151.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f6f6f",
    d: "M 1852.5,424.5 C 1852.56,429.203 1852.23,433.87 1851.5,438.5C 1850.83,439.5 1850.17,440.5 1849.5,441.5C 1850.58,435.718 1851.58,430.051 1852.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a1a1a1",
    d: "M 329.5,416.5 C 329.414,420.857 329.08,425.19 328.5,429.5C 327.321,435.342 323.988,439.342 318.5,441.5C 263.167,441.5 207.833,441.5 152.5,441.5C 207.833,440.833 263.167,440.167 318.5,439.5C 322.483,437.682 325.316,434.682 327,430.5C 327.116,425.566 327.949,420.9 329.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a2a2a2",
    d: "M 902.5,396.5 C 902.833,396.5 903.167,396.5 903.5,396.5C 897.661,414.732 891.328,432.732 884.5,450.5C 883.593,452.657 882.927,454.99 882.5,457.5C 881.833,458.167 881.167,458.833 880.5,459.5C 885.015,445.42 889.515,431.42 894,417.5C 897.204,411.164 899.537,404.497 901,397.5C 901.383,396.944 901.883,396.611 902.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a8a8a8",
    d: "M 963.5,424.5 C 963.833,424.5 964.167,424.5 964.5,424.5C 963.173,430.136 961.673,435.802 960,441.5C 940.726,493.247 922.06,545.247 904,597.5C 903.617,598.056 903.117,598.389 902.5,598.5C 902.167,598.5 901.833,598.5 901.5,598.5C 909.634,574.606 917.967,550.94 926.5,527.5C 927.945,525.429 928.945,523.096 929.5,520.5C 933.274,508.649 937.274,496.982 941.5,485.5C 942.906,485.027 943.573,484.027 943.5,482.5C 943.691,479.017 944.357,475.684 945.5,472.5C 946.79,471.942 947.623,470.942 948,469.5C 949.174,465.822 950.341,462.156 951.5,458.5C 955.799,447.324 959.799,435.99 963.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d3d3d3",
    d: "M 318.5,439.5 C 263.167,440.167 207.833,440.833 152.5,441.5C 151.662,441.842 151.328,442.508 151.5,443.5C 150.566,442.432 150.232,441.099 150.5,439.5C 206.5,439.5 262.5,439.5 318.5,439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707070",
    d: "M 393.5,437.5 C 393.946,440.01 393.28,442.01 391.5,443.5C 391.875,441.302 392.542,439.302 393.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 1580.5,384.5 C 1644.33,383.501 1708.33,383.168 1772.5,383.5C 1780.29,384.955 1784.62,389.621 1785.5,397.5C 1786.83,407.167 1786.83,416.833 1785.5,426.5C 1784.44,434.231 1780.11,439.231 1772.5,441.5C 1715.16,441.167 1657.83,441.5 1600.5,442.5C 1600.62,443.107 1600.96,443.44 1601.5,443.5C 1609.15,451.823 1616.48,460.49 1623.5,469.5C 1615.57,461.234 1607.57,452.901 1599.5,444.5C 1598,442.167 1598.5,440.501 1601,439.5C 1656.47,440.22 1711.81,440.553 1767,440.5C 1779.27,439.56 1785.27,432.893 1785,420.5C 1786.18,410.513 1785.18,400.847 1782,391.5C 1780.12,388.616 1777.62,386.449 1774.5,385C 1709.83,384.5 1645.17,384.333 1580.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#535353",
    d: "M 152.5,441.5 C 207.833,441.5 263.167,441.5 318.5,441.5C 263.5,442.167 208.5,442.833 153.5,443.5C 152.662,443.158 152.328,442.492 152.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585858",
    d: "M 1772.5,441.5 C 1715.5,442.167 1658.5,442.833 1601.5,443.5C 1600.96,443.44 1600.62,443.107 1600.5,442.5C 1657.83,441.5 1715.16,441.167 1772.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#ababab",
    d: "M 972.5,435.5 C 973.79,436.058 974.623,437.058 975,438.5C 976.536,445.075 978.703,451.408 981.5,457.5C 981.707,460.241 982.707,462.574 984.5,464.5C 987.219,471.66 989.553,478.993 991.5,486.5C 991.66,488.153 992.326,489.486 993.5,490.5C 995.139,494.388 996.473,498.388 997.5,502.5C 997.977,505.438 998.977,508.104 1000.5,510.5C 1000.5,510.833 1000.5,511.167 1000.5,511.5C 1001.23,512.708 1001.57,514.041 1001.5,515.5C 999.732,513.078 998.232,510.412 997,507.5C 989.021,483.259 980.854,459.259 972.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b3b3b3",
    d: "M 1047.5,447.5 C 1051.22,454.02 1053.89,461.02 1055.5,468.5C 1055.17,468.5 1054.83,468.5 1054.5,468.5C 1053.41,465.943 1052.41,463.276 1051.5,460.5C 1050.91,457.937 1049.91,455.604 1048.5,453.5C 1048.17,451.5 1047.83,449.5 1047.5,447.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a5a5a5",
    d: "M 393.5,436.5 C 393.833,436.5 394.167,436.5 394.5,436.5C 393.042,446.708 389.875,456.375 385,465.5C 380.754,470.991 376.754,476.658 373,482.5C 369.902,486.107 366.402,489.107 362.5,491.5C 366.589,486.345 370.923,481.345 375.5,476.5C 383.165,466.662 388.498,455.662 391.5,443.5C 393.28,442.01 393.946,440.01 393.5,437.5C 393.5,437.167 393.5,436.833 393.5,436.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c9c9c",
    d: "M 1851.5,438.5 C 1850.09,448.308 1846.75,457.308 1841.5,465.5C 1844.29,457.506 1846.96,449.506 1849.5,441.5C 1850.17,440.5 1850.83,439.5 1851.5,438.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383838",
    d: "M 884.5,450.5 C 884.662,452.527 884.495,454.527 884,456.5C 883.617,457.056 883.117,457.389 882.5,457.5C 882.927,454.99 883.593,452.657 884.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#404040",
    d: "M 1048.5,453.5 C 1049.91,455.604 1050.91,457.937 1051.5,460.5C 1049.18,458.815 1048.18,456.481 1048.5,453.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f3f3f",
    d: "M 981.5,457.5 C 983.293,459.426 984.293,461.759 984.5,464.5C 982.707,462.574 981.707,460.241 981.5,457.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d3d3d",
    d: "M 1140.5,458.5 C 1139.31,461.612 1137.98,464.612 1136.5,467.5C 1135.93,463.513 1137.26,460.513 1140.5,458.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#aeaeae",
    d: "M 880.5,460.5 C 880.567,461.959 880.234,463.292 879.5,464.5C 879.5,465.167 879.167,465.5 878.5,465.5C 878.12,463.302 878.787,461.635 880.5,460.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383838",
    d: "M 882.5,457.5 C 882.66,459.199 882.494,460.866 882,462.5C 881.583,463.756 880.75,464.423 879.5,464.5C 880.234,463.292 880.567,461.959 880.5,460.5C 880.5,460.167 880.5,459.833 880.5,459.5C 881.167,458.833 881.833,458.167 882.5,457.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#9e9e9e",
    d: "M 1079.5,430.5 C 1079.5,431.5 1079.5,432.5 1079.5,433.5C 1074.73,446.396 1069.9,459.396 1065,472.5C 1064.15,476.189 1063.32,479.856 1062.5,483.5C 1060.86,483.714 1059.36,483.38 1058,482.5C 1056.27,478.027 1055.1,473.361 1054.5,468.5C 1054.83,468.5 1055.17,468.5 1055.5,468.5C 1057.04,472.433 1058.71,476.433 1060.5,480.5C 1066.85,463.713 1073.18,447.046 1079.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#9c9c9c",
    d: "M 858.5,444.5 C 862.826,456.158 866.993,467.824 871,479.5C 871.414,479.957 871.914,480.291 872.5,480.5C 874.057,475.214 876.057,470.214 878.5,465.5C 877.321,471.217 875.821,476.883 874,482.5C 873.311,483.357 872.478,484.023 871.5,484.5C 867.33,473.495 863.164,462.495 859,451.5C 858.503,449.19 858.337,446.857 858.5,444.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e2e2e",
    d: "M 951.5,458.5 C 950.341,462.156 949.174,465.822 948,469.5C 947.623,470.942 946.79,471.942 945.5,472.5C 945.751,470.83 946.418,469.33 947.5,468C 947.167,467.667 946.833,467.333 946.5,467C 948.094,463.913 949.76,461.08 951.5,458.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#9c9c9c",
    d: "M 1841.5,466.5 C 1832.07,484.431 1818.07,497.265 1799.5,505C 1793.68,506.95 1787.68,507.783 1781.5,507.5C 1770.5,507.5 1759.5,507.5 1748.5,507.5C 1762.17,506.833 1775.83,506.167 1789.5,505.5C 1792.37,505.198 1795.04,504.531 1797.5,503.5C 1815.44,496.409 1829.27,484.409 1839,467.5C 1839.67,466.748 1840.5,466.414 1841.5,466.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a8a8a8",
    d: "M 1623.5,469.5 C 1627.13,472.629 1630.63,475.963 1634,479.5C 1635.75,481.734 1637.25,484.068 1638.5,486.5C 1632.8,481.437 1627.8,475.771 1623.5,469.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#676767",
    d: "M 943.5,482.5 C 943.573,484.027 942.906,485.027 941.5,485.5C 941.427,483.973 942.094,482.973 943.5,482.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#676767",
    d: "M 991.5,486.5 C 993.104,487.287 993.771,488.62 993.5,490.5C 992.326,489.486 991.66,488.153 991.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#bdbdbd",
    d: "M 1271.5,491.5 C 1339.83,491.5 1408.17,491.5 1476.5,491.5C 1408.34,492.499 1340,492.833 1271.5,492.5C 1271.5,505.833 1271.5,519.167 1271.5,532.5C 1344.67,532.167 1417.67,532.501 1490.5,533.5C 1417.5,533.5 1344.5,533.5 1271.5,533.5C 1270.17,519.5 1270.17,505.5 1271.5,491.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a5a5a5",
    d: "M 362.5,491.5 C 360.704,493.9 358.37,495.567 355.5,496.5C 356.992,493.677 359.326,492.01 362.5,491.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#353535",
    d: "M 1797.5,503.5 C 1795.04,504.531 1792.37,505.198 1789.5,505.5C 1791.64,503.631 1794.3,502.964 1797.5,503.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#aaaaaa",
    d: "M 1638.5,486.5 C 1640.44,488.091 1642.44,489.758 1644.5,491.5C 1651.76,499.719 1658.76,508.052 1665.5,516.5C 1655.81,507.143 1646.81,497.143 1638.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#a4a4a4",
    d: "M 152.5,441.5 C 152.328,442.492 152.662,443.158 153.5,443.5C 173.938,464.438 194.605,485.272 215.5,506C 252.5,506.667 289.5,506.667 326.5,506C 332.8,505.307 338.8,503.807 344.5,501.5C 346.75,500.87 348.75,499.87 350.5,498.5C 351.78,497.069 353.447,496.402 355.5,496.5C 351.059,500.163 346.059,502.996 340.5,505C 333.393,506.774 326.226,507.941 319,508.5C 285,507.167 251,507.167 217,508.5C 194.66,487.327 172.827,465.66 151.5,443.5C 151.328,442.508 151.662,441.842 152.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M 350.5,498.5 C 348.75,499.87 346.75,500.87 344.5,501.5C 345.784,499.386 347.784,498.386 350.5,498.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#545454",
    d: "M 997.5,502.5 C 999.515,504.707 1000.51,507.374 1000.5,510.5C 998.977,508.104 997.977,505.438 997.5,502.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7b7b7",
    d: "M 1748.5,507.5 C 1759.5,507.5 1770.5,507.5 1781.5,507.5C 1780.74,508.268 1779.74,508.768 1778.5,509C 1769.96,509.79 1761.46,509.623 1753,508.5C 1752.5,508.833 1752,509.167 1751.5,509.5C 1752.95,510.94 1753.95,512.606 1754.5,514.5C 1751.41,513.08 1749.41,510.747 1748.5,507.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#c5c5c5",
    d: "M 1754.5,514.5 C 1755.83,514.5 1756.5,515.167 1756.5,516.5C 1755.5,516.167 1754.83,515.5 1754.5,514.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acacac",
    d: "M 1756.5,516.5 C 1759.83,519.167 1762.83,522.167 1765.5,525.5C 1763.94,525.267 1762.6,524.6 1761.5,523.5C 1759.42,521.427 1757.75,519.093 1756.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#aeaeae",
    d: "M 1171.5,374.5 C 1149.11,438.7 1126.11,502.7 1102.5,566.5C 1102.4,563.308 1103.07,560.308 1104.5,557.5C 1115.17,527.531 1125.83,497.531 1136.5,467.5C 1137.98,464.612 1139.31,461.612 1140.5,458.5C 1141.66,453.007 1143.33,447.673 1145.5,442.5C 1146.12,442.389 1146.62,442.056 1147,441.5C 1148.4,435.793 1149.9,430.126 1151.5,424.5C 1152.99,421.527 1154.32,418.527 1155.5,415.5C 1157.92,410.195 1159.58,404.528 1160.5,398.5C 1162.2,395.744 1163.54,392.744 1164.5,389.5C 1166.38,384.319 1168.72,379.319 1171.5,374.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#808080",
    d: "M 1000.5,511.5 C 1001.65,511.791 1002.32,512.624 1002.5,514C 1003.62,516.731 1004.28,519.565 1004.5,522.5C 1004.17,522.5 1003.83,522.5 1003.5,522.5C 1002.06,520.412 1001.39,518.079 1001.5,515.5C 1001.57,514.041 1001.23,512.708 1000.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ababab",
    d: "M 681.5,517.5 C 681.483,519.565 681.15,521.565 680.5,523.5C 679.833,523.833 679.167,524.167 678.5,524.5C 678.707,521.759 679.707,519.426 681.5,517.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f3f3f",
    d: "M 929.5,520.5 C 928.945,523.096 927.945,525.429 926.5,527.5C 926.464,524.539 927.464,522.206 929.5,520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#cacaca",
    d: "M 412.5,518.5 C 412.833,518.5 413.167,518.5 413.5,518.5C 413.5,519.167 413.5,519.833 413.5,520.5C 413.423,524.215 413.756,527.881 414.5,531.5C 413.883,531.389 413.383,531.056 413,530.5C 412.501,526.514 412.334,522.514 412.5,518.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#696969",
    d: "M 413.5,520.5 C 414.687,523.946 415.354,527.613 415.5,531.5C 415.167,531.5 414.833,531.5 414.5,531.5C 413.756,527.881 413.423,524.215 413.5,520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#494949",
    d: "M 1761.5,523.5 C 1762.6,524.6 1763.94,525.267 1765.5,525.5C 1766.34,525.842 1766.67,526.508 1766.5,527.5C 1766.5,528.167 1766.5,528.833 1766.5,529.5C 1764.14,528.135 1762.47,526.135 1761.5,523.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848484",
    d: "M 481.5,523.5 C 482.167,523.833 482.833,524.167 483.5,524.5C 486.205,526.512 488.872,528.512 491.5,530.5C 491.5,530.833 491.5,531.167 491.5,531.5C 486.951,530.241 483.618,527.574 481.5,523.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acacac",
    d: "M 678.5,524.5 C 677.047,528.226 674.381,530.559 670.5,531.5C 668.139,531.674 665.806,532.007 663.5,532.5C 667.108,531.063 670.775,529.563 674.5,528C 675.532,526.373 676.866,525.207 678.5,524.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M 748.5,515.5 C 748.037,518.482 747.704,521.482 747.5,524.5C 747.167,530.516 745.834,536.183 743.5,541.5C 744.8,532.717 746.467,524.05 748.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#9c9c9c",
    d: "M 1665.5,516.5 C 1667.02,516.511 1668.18,517.177 1669,518.5C 1674.52,525.503 1680.52,532.17 1687,538.5C 1691,543.995 1695.17,549.329 1699.5,554.5C 1687.25,542.669 1675.91,530.002 1665.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a1a1a1",
    d: "M 1766.5,527.5 C 1769.9,529.9 1772.57,532.9 1774.5,536.5C 1771.75,534.147 1769.09,531.814 1766.5,529.5C 1766.5,528.833 1766.5,528.167 1766.5,527.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b8b8b8",
    d: "M 491.5,531.5 C 491.5,531.167 491.5,530.833 491.5,530.5C 493.989,530.298 496.323,530.798 498.5,532C 553.499,532.5 608.499,532.667 663.5,532.5C 663.5,532.833 663.5,533.167 663.5,533.5C 607.166,533.667 550.832,533.5 494.5,533C 493.756,531.961 492.756,531.461 491.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707070",
    d: "M 670.5,531.5 C 668.485,532.924 666.152,533.59 663.5,533.5C 663.5,533.167 663.5,532.833 663.5,532.5C 665.806,532.007 668.139,531.674 670.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ababab",
    d: "M 1774.5,536.5 C 1778.23,539.231 1781.23,542.564 1783.5,546.5C 1779.77,543.769 1776.77,540.436 1774.5,536.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#acacac",
    d: "M 749.5,521.5 C 748.589,536.204 743.589,549.204 734.5,560.5C 737.677,554.329 740.677,547.996 743.5,541.5C 745.834,536.183 747.167,530.516 747.5,524.5C 748.167,523.5 748.833,522.5 749.5,521.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b2b2b",
    d: "M 823.5,542.5 C 825.442,545.234 826.942,548.234 828,551.5C 828.495,553.473 828.662,555.473 828.5,557.5C 826.396,552.796 824.729,547.796 823.5,542.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363636",
    d: "M 1787.5,552.5 C 1789.59,553.585 1790.92,555.251 1791.5,557.5C 1789.99,556.164 1788.32,554.997 1786.5,554C 1787.06,553.617 1787.39,553.117 1787.5,552.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#a9a9a9",
    d: "M 1003.5,522.5 C 1003.83,522.5 1004.17,522.5 1004.5,522.5C 1010.61,537.54 1016.45,552.874 1022,568.5C 1024.49,577.502 1027.65,586.169 1031.5,594.5C 1031.5,595.5 1031.5,596.5 1031.5,597.5C 1031.17,597.5 1030.83,597.5 1030.5,597.5C 1021.04,572.66 1012.04,547.66 1003.5,522.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#aaaaaa",
    d: "M 1783.5,546.5 C 1789.97,552.78 1795.97,559.447 1801.5,566.5C 1799.5,564.833 1797.5,563.167 1795.5,561.5C 1794.5,559.833 1793.17,558.5 1791.5,557.5C 1790.92,555.251 1789.59,553.585 1787.5,552.5C 1785.67,550.853 1784.34,548.853 1783.5,546.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M 1795.5,561.5 C 1797.5,563.167 1799.5,564.833 1801.5,566.5C 1801.83,567.5 1802.5,568.167 1803.5,568.5C 1803.56,569.609 1803.89,570.609 1804.5,571.5C 1800.82,568.815 1797.82,565.482 1795.5,561.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a0a0a0",
    d: "M 414.5,531.5 C 414.833,531.5 415.167,531.5 415.5,531.5C 418.311,541.736 422.478,551.403 428,560.5C 435.133,568.797 442.633,576.463 450.5,583.5C 431.049,571.246 419.049,553.913 414.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#343434",
    d: "M 1104.5,557.5 C 1103.07,560.308 1102.4,563.308 1102.5,566.5C 1101.02,567.448 1100.02,568.781 1099.5,570.5C 1099.46,567.179 1100.13,564.012 1101.5,561C 1101.72,559.092 1102.72,557.926 1104.5,557.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#9e9e9e",
    d: "M 1699.5,554.5 C 1701.23,555.117 1702.73,556.117 1704,557.5C 1711.63,566.797 1719.63,575.797 1728,584.5C 1728.79,585.745 1729.29,587.078 1729.5,588.5C 1719.13,577.469 1709.13,566.136 1699.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#c5c5c5",
    d: "M 1801.5,566.5 C 1802.83,566.5 1803.5,567.167 1803.5,568.5C 1802.5,568.167 1801.83,567.5 1801.5,566.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#b9b9b9",
    d: "M 1102.5,566.5 C 1101.91,570.579 1100.58,574.246 1098.5,577.5C 1098.5,576.167 1098.5,574.833 1098.5,573.5C 1098.56,572.391 1098.89,571.391 1099.5,570.5C 1100.02,568.781 1101.02,567.448 1102.5,566.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a9a9a9",
    d: "M 734.5,560.5 C 732.638,564.542 730.138,568.208 727,571.5C 725.549,573.464 723.716,574.797 721.5,575.5C 725.489,570.179 729.822,565.179 734.5,560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a2a2a2",
    d: "M 1803.5,568.5 C 1806.57,570.569 1808.91,573.236 1810.5,576.5C 1808.46,574.823 1806.46,573.156 1804.5,571.5C 1803.89,570.609 1803.56,569.609 1803.5,568.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#b5b5b5",
    d: "M 1810.5,576.5 C 1814.18,579.185 1817.18,582.518 1819.5,586.5C 1815.79,583.789 1812.79,580.456 1810.5,576.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8f",
    d: "M 1098.5,573.5 C 1098.5,574.833 1098.5,576.167 1098.5,577.5C 1097.61,580.82 1096.27,583.82 1094.5,586.5C 1094.84,581.706 1096.18,577.373 1098.5,573.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a7a7a7",
    d: "M 450.5,583.5 C 452.027,583.427 453.027,584.094 453.5,585.5C 451.973,585.573 450.973,584.906 450.5,583.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#bababa",
    d: "M 453.5,585.5 C 456.198,585.845 458.198,587.178 459.5,589.5C 457.147,588.66 455.147,587.326 453.5,585.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3c3c",
    d: "M 839.5,586.5 C 841.278,589.902 842.611,593.569 843.5,597.5C 842.143,596.41 841.143,595.076 840.5,593.5C 840.326,591.139 839.993,588.806 839.5,586.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b1b1b1",
    d: "M 1819.5,586.5 C 1824.14,590.14 1828.14,594.473 1831.5,599.5C 1831.04,600.298 1830.38,600.631 1829.5,600.5C 1829.77,598.62 1829.1,597.287 1827.5,596.5C 1826.83,595.167 1825.83,594.167 1824.5,593.5C 1822.45,591.445 1820.78,589.112 1819.5,586.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#bababa",
    d: "M 1094.5,586.5 C 1093.97,590.212 1093.14,593.879 1092,597.5C 1091.62,598.056 1091.12,598.389 1090.5,598.5C 1090.5,597.5 1090.5,596.5 1090.5,595.5C 1091.55,592.392 1092.89,589.392 1094.5,586.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#b3b3b3",
    d: "M 1729.5,588.5 C 1732.12,590.782 1734.79,593.115 1737.5,595.5C 1737.5,596.167 1737.5,596.833 1737.5,597.5C 1734.12,595.12 1731.45,592.12 1729.5,588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b8b8b8",
    d: "M 459.5,589.5 C 462.238,589.706 464.572,590.706 466.5,592.5C 463.762,592.294 461.428,591.294 459.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#9f9f9f",
    d: "M 721.5,575.5 C 710.501,587.001 697.167,594.335 681.5,597.5C 679.784,597.629 678.117,597.962 676.5,598.5C 676.611,597.883 676.944,597.383 677.5,597C 686.637,595.117 695.304,592.117 703.5,588C 709.122,583.198 715.122,579.031 721.5,575.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M 1031.5,594.5 C 1032.4,595.209 1032.74,596.209 1032.5,597.5C 1050.86,596.847 1068.86,597.513 1086.5,599.5C 1068.13,599.794 1049.8,599.461 1031.5,598.5C 1031.5,598.167 1031.5,597.833 1031.5,597.5C 1031.5,596.5 1031.5,595.5 1031.5,594.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6b6b",
    d: "M 1204.5,317.5 C 1204.17,411.001 1204.5,504.335 1205.5,597.5C 1299.74,598.169 1394.07,598.836 1488.5,599.5C 1488.83,599.5 1489.17,599.5 1489.5,599.5C 1394.63,600.832 1299.63,600.832 1204.5,599.5C 1203.17,505.334 1203.17,411.334 1204.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4b4b",
    d: "M 1824.5,593.5 C 1825.83,594.167 1826.83,595.167 1827.5,596.5C 1827.5,597.5 1827.5,598.5 1827.5,599.5C 1799.5,599.5 1771.5,599.5 1743.5,599.5C 1770.33,598.502 1797.33,598.169 1824.5,598.5C 1825.38,598.631 1826.04,598.298 1826.5,597.5C 1825.37,596.378 1824.7,595.044 1824.5,593.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#797979",
    d: "M 466.5,592.5 C 474.422,594.519 482.422,596.352 490.5,598C 549.166,598.5 607.832,598.667 666.5,598.5C 665.391,599.29 664.058,599.79 662.5,600C 605.487,600.805 548.487,600.638 491.5,599.5C 483.283,598.821 475.283,596.988 467.5,594C 466.944,593.617 466.611,593.117 466.5,592.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878787",
    d: "M 1090.5,595.5 C 1090.5,596.5 1090.5,597.5 1090.5,598.5C 1089.71,598.783 1089.04,599.283 1088.5,600C 1070.17,600.667 1051.83,600.667 1033.5,600C 1032.58,599.722 1031.92,599.222 1031.5,598.5C 1049.8,599.461 1068.13,599.794 1086.5,599.5C 1088.19,598.473 1089.53,597.139 1090.5,595.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6a6a",
    d: "M 1579.5,384.5 C 1579.67,456.167 1579.5,527.834 1579,599.5C 1557.4,600.831 1535.9,600.831 1514.5,599.5C 1515.17,599.5 1515.83,599.5 1516.5,599.5C 1537.13,598.513 1557.63,598.179 1578,598.5C 1578.17,526.999 1578.67,455.665 1579.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888888",
    d: "M 1737.5,595.5 C 1738.17,596.167 1738.83,596.833 1739.5,597.5C 1740.67,598.345 1742,599.011 1743.5,599.5C 1771.5,599.5 1799.5,599.5 1827.5,599.5C 1827.5,598.5 1827.5,597.5 1827.5,596.5C 1829.1,597.287 1829.77,598.62 1829.5,600.5C 1799.46,600.818 1769.46,600.484 1739.5,599.5C 1738.5,599.167 1737.83,598.5 1737.5,597.5C 1737.5,596.833 1737.5,596.167 1737.5,595.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 1739.5,597.5 C 1768,597.169 1796.34,597.502 1824.5,598.5C 1797.33,598.169 1770.33,598.502 1743.5,599.5C 1742,599.011 1740.67,598.345 1739.5,597.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d0d0d0",
    d: "M 681.5,597.5 C 681.082,598.222 680.416,598.722 679.5,599C 674.771,599.273 670.104,599.939 665.5,601C 608.833,601.667 552.167,601.667 495.5,601C 493.942,600.79 492.609,600.29 491.5,599.5C 548.487,600.638 605.487,600.805 662.5,600C 664.058,599.79 665.391,599.29 666.5,598.5C 669.833,598.5 673.167,598.5 676.5,598.5C 678.117,597.962 679.784,597.629 681.5,597.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#cfcfcf",
    d: "M 840.5,593.5 C 841.143,595.076 842.143,596.41 843.5,597.5C 843.833,598.167 844.167,598.833 844.5,599.5C 862.995,600.662 881.662,600.829 900.5,600C 901.056,599.617 901.389,599.117 901.5,598.5C 901.833,598.5 902.167,598.5 902.5,598.5C 902.586,599.496 902.252,600.329 901.5,601C 882.167,601.667 862.833,601.667 843.5,601C 841.307,598.975 840.307,596.475 840.5,593.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767676",
    d: "M 901.5,598.5 C 901.389,599.117 901.056,599.617 900.5,600C 881.662,600.829 862.995,600.662 844.5,599.5C 863.603,598.531 882.603,598.198 901.5,598.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d2d2d2",
    d: "M 1030.5,597.5 C 1030.83,597.5 1031.17,597.5 1031.5,597.5C 1031.5,597.833 1031.5,598.167 1031.5,598.5C 1031.92,599.222 1032.58,599.722 1033.5,600C 1051.83,600.667 1070.17,600.667 1088.5,600C 1089.04,599.283 1089.71,598.783 1090.5,598.5C 1090.59,599.496 1090.25,600.329 1089.5,601C 1070.5,601.667 1051.5,601.667 1032.5,601C 1031.03,600.29 1030.36,599.124 1030.5,597.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d3d3d3",
    d: "M 1204.5,316.5 C 1204.5,316.833 1204.5,317.167 1204.5,317.5C 1203.17,411.334 1203.17,505.334 1204.5,599.5C 1299.63,600.832 1394.63,600.832 1489.5,599.5C 1489.83,598.833 1490.17,598.167 1490.5,597.5C 1491.5,576.34 1491.83,555.007 1491.5,533.5C 1492.66,555.329 1492.83,577.329 1492,599.5C 1491.5,600 1491,600.5 1490.5,601C 1394.79,601.831 1299.13,601.664 1203.5,600.5C 1203.17,553.167 1202.83,505.833 1202.5,458.5C 1202.5,410.829 1203.17,363.495 1204.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707070",
    d: "M 1271.5,533.5 C 1344.5,533.5 1417.5,533.5 1490.5,533.5C 1490.83,533.5 1491.17,533.5 1491.5,533.5C 1491.83,555.007 1491.5,576.34 1490.5,597.5C 1490.83,576.327 1490.5,555.327 1489.5,534.5C 1416.66,534.833 1344,534.499 1271.5,533.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4c4c",
    d: "M 1489.5,534.5 C 1490.5,555.327 1490.83,576.327 1490.5,597.5C 1490.17,598.167 1489.83,598.833 1489.5,599.5C 1489.17,599.5 1488.83,599.5 1488.5,599.5C 1489.47,577.866 1489.8,556.2 1489.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d3d3d3",
    d: "M 1739.5,599.5 C 1769.46,600.484 1799.46,600.818 1829.5,600.5C 1800,601.664 1770.34,601.831 1740.5,601C 1739.94,600.617 1739.61,600.117 1739.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d0d0d0",
    d: "M 1074.5,628.5 C 1071.87,627.908 1069.21,627.575 1066.5,627.5C 1064.5,627.5 1062.5,627.5 1060.5,627.5C 1059.05,626.698 1057.38,626.198 1055.5,626C 994.472,625.178 933.472,625.345 872.5,626.5C 871.167,626.5 869.833,626.5 868.5,626.5C 869.263,625.732 870.263,625.232 871.5,625C 934.833,624.333 998.167,624.333 1061.5,625C 1066.05,625.839 1070.38,627.005 1074.5,628.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656565",
    d: "M 1060.5,627.5 C 998.833,627.5 937.167,627.5 875.5,627.5C 874.5,627.5 873.5,627.5 872.5,627.5C 872.5,627.167 872.5,626.833 872.5,626.5C 933.472,625.345 994.472,625.178 1055.5,626C 1057.38,626.198 1059.05,626.698 1060.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d2d2d2",
    d: "M 1433.5,631.5 C 1432.5,631.5 1431.5,631.5 1430.5,631.5C 1428.09,629.949 1425.42,629.283 1422.5,629.5C 1420.56,627.837 1418.23,627.171 1415.5,627.5C 1412.83,627.5 1410.17,627.5 1407.5,627.5C 1406.39,626.71 1405.06,626.21 1403.5,626C 1321.5,625.333 1239.5,625.333 1157.5,626C 1156.58,626.374 1155.75,626.874 1155,627.5C 1154.17,721.334 1154.33,815.001 1155.5,908.5C 1155.83,908.5 1156.17,908.5 1156.5,908.5C 1156.5,908.833 1156.5,909.167 1156.5,909.5C 1155.5,909.5 1154.5,909.5 1153.5,909.5C 1153.33,815.166 1153.5,720.833 1154,626.5C 1154.5,626 1155,625.5 1155.5,625C 1240.17,624.333 1324.83,624.333 1409.5,625C 1416.21,626.072 1422.88,627.405 1429.5,629C 1431.07,629.608 1432.4,630.442 1433.5,631.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#686868",
    d: "M 1407.5,627.5 C 1323.67,627.167 1240,627.501 1156.5,628.5C 1156.49,720.588 1156.49,812.921 1156.5,905.5C 1155.83,905.5 1155.5,905.833 1155.5,906.5C 1155.5,907.167 1155.5,907.833 1155.5,908.5C 1154.33,815.001 1154.17,721.334 1155,627.5C 1155.75,626.874 1156.58,626.374 1157.5,626C 1239.5,625.333 1321.5,625.333 1403.5,626C 1405.06,626.21 1406.39,626.71 1407.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d0d0d0",
    d: "M 1800.5,692.5 C 1800.5,691.833 1800.5,691.167 1800.5,690.5C 1800.5,690.167 1800.5,689.833 1800.5,689.5C 1800.83,668.258 1800.49,647.091 1799.5,626C 1704.83,625.333 1610.17,625.333 1515.5,626C 1514.94,626.383 1514.61,626.883 1514.5,627.5C 1513.17,673.995 1512.5,720.829 1512.5,768C 1512.5,815.171 1513.17,862.005 1514.5,908.5C 1514.5,908.833 1514.5,909.167 1514.5,909.5C 1513.5,909.5 1512.5,909.5 1511.5,909.5C 1511.33,815.166 1511.5,720.833 1512,626.5C 1512.5,626 1513,625.5 1513.5,625C 1609.17,624.333 1704.83,624.333 1800.5,625C 1801.83,647.598 1801.83,670.098 1800.5,692.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#636363",
    d: "M 1800.5,689.5 C 1799.5,669.007 1799.17,648.34 1799.5,627.5C 1704.83,627.5 1610.17,627.5 1515.5,627.5C 1515.17,627.5 1514.83,627.5 1514.5,627.5C 1514.61,626.883 1514.94,626.383 1515.5,626C 1610.17,625.333 1704.83,625.333 1799.5,626C 1800.49,647.091 1800.83,668.258 1800.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M 875.5,627.5 C 937.167,627.5 998.833,627.5 1060.5,627.5C 1062.5,627.5 1064.5,627.5 1066.5,627.5C 1068.91,628.768 1071.57,629.435 1074.5,629.5C 1080.83,631.165 1086.83,633.665 1092.5,637C 1097.99,640.992 1103.32,645.158 1108.5,649.5C 1118.15,661.473 1125.15,674.806 1129.5,689.5C 1129.42,692.781 1130.09,695.781 1131.5,698.5C 1131.5,699.167 1131.5,699.833 1131.5,700.5C 1131.5,769.833 1131.5,839.167 1131.5,908.5C 1109.83,908.5 1088.17,908.5 1066.5,908.5C 1066.5,878.833 1066.5,849.167 1066.5,819.5C 1000.17,819.5 933.833,819.5 867.5,819.5C 866.833,819.5 866.167,819.5 865.5,819.5C 864.502,848.662 864.169,877.995 864.5,907.5C 843.993,907.17 823.66,907.503 803.5,908.5C 802.833,908.5 802.167,908.5 801.5,908.5C 800.501,843.335 800.168,778.002 800.5,712.5C 801.398,706.334 802.064,700 802.5,693.5C 803.49,690.261 804.49,686.928 805.5,683.5C 805.263,682.209 805.596,681.209 806.5,680.5C 808.517,677.101 810.184,673.434 811.5,669.5C 811.5,668.5 811.5,667.5 811.5,666.5C 817.247,658.58 823.58,651.08 830.5,644C 838.048,637.895 846.381,633.395 855.5,630.5C 862.245,629.642 868.912,628.642 875.5,627.5 Z M 1065.5,749.5 C 1065.39,750.117 1065.06,750.617 1064.5,751C 999.167,751.667 933.833,751.667 868.5,751C 868.47,735.042 868.47,718.875 868.5,702.5C 869.934,699.953 871.6,697.619 873.5,695.5C 875.307,694.385 877.307,693.719 879.5,693.5C 937.792,694.751 996.125,694.751 1054.5,693.5C 1059.17,694.838 1062.17,697.838 1063.5,702.5C 1063.39,703.442 1063.06,704.275 1062.5,705C 1064.6,706.733 1064.93,708.733 1063.5,711C 1064.16,723.931 1064.82,736.765 1065.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727272",
    d: "M 1066.5,627.5 C 1069.21,627.575 1071.87,627.908 1074.5,628.5C 1074.5,628.833 1074.5,629.167 1074.5,629.5C 1071.57,629.435 1068.91,628.768 1066.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 1407.5,627.5 C 1410.17,627.5 1412.83,627.5 1415.5,627.5C 1417.6,628.612 1419.93,629.279 1422.5,629.5C 1425.42,629.283 1428.09,629.949 1430.5,631.5C 1439.5,635.063 1448.17,639.396 1456.5,644.5C 1457.26,646.262 1458.6,647.262 1460.5,647.5C 1462.14,649.481 1463.81,651.481 1465.5,653.5C 1468.38,657.949 1471.71,661.949 1475.5,665.5C 1476.17,665.833 1476.83,666.167 1477.5,666.5C 1479.08,671.612 1481.42,676.279 1484.5,680.5C 1484.34,682.527 1484.5,684.527 1485,686.5C 1485.38,687.056 1485.88,687.389 1486.5,687.5C 1487.37,691.198 1488.37,694.865 1489.5,698.5C 1489.5,701.833 1489.5,705.167 1489.5,708.5C 1488.5,747.667 1488.5,787 1489.5,826.5C 1489.5,830.167 1489.5,833.833 1489.5,837.5C 1489.5,837.833 1489.5,838.167 1489.5,838.5C 1488.08,840.515 1487.41,842.848 1487.5,845.5C 1487.74,846.791 1487.4,847.791 1486.5,848.5C 1483.85,849.457 1483.18,851.124 1484.5,853.5C 1483.7,855.042 1483.37,856.708 1483.5,858.5C 1480.01,863.899 1476.34,869.232 1472.5,874.5C 1465.33,881.832 1457.66,888.666 1449.5,895C 1445.21,895.844 1441.54,897.678 1438.5,900.5C 1436.2,901.06 1433.87,901.56 1431.5,902C 1430.06,902.377 1429.06,903.21 1428.5,904.5C 1423.17,905.664 1417.84,906.664 1412.5,907.5C 1326.79,907.828 1241.13,907.495 1155.5,906.5C 1155.5,905.833 1155.83,905.5 1156.5,905.5C 1157.83,813.264 1157.83,720.931 1156.5,628.5C 1240,627.501 1323.67,627.167 1407.5,627.5 Z M 1413.5,695.5 C 1416.15,697.479 1418.48,699.812 1420.5,702.5C 1422.14,706.595 1423.48,710.762 1424.5,715C 1423.17,750.333 1423.17,785.667 1424.5,821C 1423.32,831.667 1417.66,838.5 1407.5,841.5C 1406.5,841.5 1405.5,841.5 1404.5,841.5C 1343.83,841.5 1283.17,841.5 1222.5,841.5C 1222.5,792.167 1222.5,742.833 1222.5,693.5C 1283.5,693.333 1344.5,693.5 1405.5,694C 1408.06,695.079 1410.73,695.579 1413.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6c6c",
    d: "M 1415.5,627.5 C 1418.23,627.171 1420.56,627.837 1422.5,629.5C 1419.93,629.279 1417.6,628.612 1415.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616161",
    d: "M 1514.5,627.5 C 1514.5,721.167 1514.5,814.833 1514.5,908.5C 1513.17,862.005 1512.5,815.171 1512.5,768C 1512.5,720.829 1513.17,673.995 1514.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212121",
    d: "M 1514.5,627.5 C 1514.83,627.5 1515.17,627.5 1515.5,627.5C 1515.5,720.833 1515.5,814.167 1515.5,907.5C 1609.5,907.667 1703.5,907.5 1797.5,907C 1798.07,886.551 1798.4,866.051 1798.5,845.5C 1798.83,845.5 1799.17,845.5 1799.5,845.5C 1799.5,866.5 1799.5,887.5 1799.5,908.5C 1704.5,908.5 1609.5,908.5 1514.5,908.5C 1514.5,814.833 1514.5,721.167 1514.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 1515.5,627.5 C 1610.17,627.5 1704.83,627.5 1799.5,627.5C 1799.17,648.34 1799.5,669.007 1800.5,689.5C 1800.5,689.833 1800.5,690.167 1800.5,690.5C 1726.9,691.497 1653.24,691.83 1579.5,691.5C 1579.5,705.5 1579.5,719.5 1579.5,733.5C 1647.49,735.497 1715.83,736.163 1784.5,735.5C 1784.5,756.5 1784.5,777.5 1784.5,798.5C 1716.17,798.333 1647.83,798.5 1579.5,799C 1578.17,813.265 1578.17,827.431 1579.5,841.5C 1579.5,841.833 1579.5,842.167 1579.5,842.5C 1579.5,842.833 1579.5,843.167 1579.5,843.5C 1580.17,844.267 1581.01,844.934 1582,845.5C 1654,845.056 1726.17,845.056 1798.5,845.5C 1798.4,866.051 1798.07,886.551 1797.5,907C 1703.5,907.5 1609.5,907.667 1515.5,907.5C 1515.5,814.167 1515.5,720.833 1515.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M 872.5,627.5 C 873.5,627.5 874.5,627.5 875.5,627.5C 868.912,628.642 862.245,629.642 855.5,630.5C 860.773,627.997 866.439,626.997 872.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#afafaf",
    d: "M 1074.5,629.5 C 1074.5,629.167 1074.5,628.833 1074.5,628.5C 1088.38,631.436 1099.71,638.436 1108.5,649.5C 1103.32,645.158 1097.99,640.992 1092.5,637C 1086.83,633.665 1080.83,631.165 1074.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 1156.5,628.5 C 1157.83,720.931 1157.83,813.264 1156.5,905.5C 1156.49,812.921 1156.49,720.588 1156.5,628.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#a2a2a2",
    d: "M 1430.5,631.5 C 1431.5,631.5 1432.5,631.5 1433.5,631.5C 1442.43,633.795 1450.09,638.128 1456.5,644.5C 1448.17,639.396 1439.5,635.063 1430.5,631.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a7a7a7",
    d: "M 868.5,626.5 C 869.833,626.5 871.167,626.5 872.5,626.5C 872.5,626.833 872.5,627.167 872.5,627.5C 866.439,626.997 860.773,627.997 855.5,630.5C 846.381,633.395 838.048,637.895 830.5,644C 823.58,651.08 817.247,658.58 811.5,666.5C 820.584,648.587 834.584,636.087 853.5,629C 858.325,627.105 863.325,626.272 868.5,626.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#bababa",
    d: "M 1456.5,644.5 C 1458.4,644.738 1459.74,645.738 1460.5,647.5C 1458.6,647.262 1457.26,646.262 1456.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b7b7b7",
    d: "M 1460.5,647.5 C 1464.85,649.855 1468.19,653.188 1470.5,657.5C 1468.83,656.167 1467.17,654.833 1465.5,653.5C 1463.81,651.481 1462.14,649.481 1460.5,647.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#b4b4b4",
    d: "M 1470.5,657.5 C 1473.92,659.592 1476.25,662.592 1477.5,666.5C 1476.83,666.167 1476.17,665.833 1475.5,665.5C 1473.83,662.833 1472.17,660.167 1470.5,657.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c2c2c",
    d: "M 1465.5,653.5 C 1467.17,654.833 1468.83,656.167 1470.5,657.5C 1472.17,660.167 1473.83,662.833 1475.5,665.5C 1471.71,661.949 1468.38,657.949 1465.5,653.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#353535",
    d: "M 811.5,669.5 C 810.184,673.434 808.517,677.101 806.5,680.5C 806.908,676.142 808.575,672.475 811.5,669.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 1108.5,649.5 C 1118.7,658.809 1125.37,670.142 1128.5,683.5C 1129.34,685.379 1129.67,687.379 1129.5,689.5C 1125.15,674.806 1118.15,661.473 1108.5,649.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b4b4b4",
    d: "M 811.5,666.5 C 811.5,667.5 811.5,668.5 811.5,669.5C 808.575,672.475 806.908,676.142 806.5,680.5C 805.596,681.209 805.263,682.209 805.5,683.5C 804.5,684.833 803.5,686.167 802.5,687.5C 804.455,679.956 807.455,672.956 811.5,666.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#cdcdcd",
    d: "M 1128.5,683.5 C 1130.31,684.918 1130.97,686.918 1130.5,689.5C 1130.17,689.5 1129.83,689.5 1129.5,689.5C 1129.67,687.379 1129.34,685.379 1128.5,683.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383838",
    d: "M 1484.5,680.5 C 1485.41,682.657 1486.07,684.99 1486.5,687.5C 1485.88,687.389 1485.38,687.056 1485,686.5C 1484.5,684.527 1484.34,682.527 1484.5,680.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7e7e",
    d: "M 805.5,683.5 C 804.49,686.928 803.49,690.261 802.5,693.5C 802.167,693.5 801.833,693.5 801.5,693.5C 801.205,691.265 801.539,689.265 802.5,687.5C 803.5,686.167 804.5,684.833 805.5,683.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6d6d",
    d: "M 1129.5,689.5 C 1129.83,689.5 1130.17,689.5 1130.5,689.5C 1130.5,689.833 1130.5,690.167 1130.5,690.5C 1131.09,693.127 1131.42,695.794 1131.5,698.5C 1130.09,695.781 1129.42,692.781 1129.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a2a2a2",
    d: "M 1477.5,666.5 C 1485.14,675.655 1489.48,686.322 1490.5,698.5C 1490.17,698.5 1489.83,698.5 1489.5,698.5C 1488.37,694.865 1487.37,691.198 1486.5,687.5C 1486.07,684.99 1485.41,682.657 1484.5,680.5C 1481.42,676.279 1479.08,671.612 1477.5,666.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5b5b5b",
    d: "M 1800.5,690.5 C 1800.5,691.167 1800.5,691.833 1800.5,692.5C 1727,692.167 1653.66,692.501 1580.5,693.5C 1580.5,706.833 1580.5,720.167 1580.5,733.5C 1580.17,733.5 1579.83,733.5 1579.5,733.5C 1579.5,719.5 1579.5,705.5 1579.5,691.5C 1653.24,691.83 1726.9,691.497 1800.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#c4c4c4",
    d: "M 1064.5,700.5 C 1065.42,716.809 1065.76,733.143 1065.5,749.5C 1064.82,736.765 1064.16,723.931 1063.5,711C 1064.93,708.733 1064.6,706.733 1062.5,705C 1063.06,704.275 1063.39,703.442 1063.5,702.5C 1062.17,697.838 1059.17,694.838 1054.5,693.5C 996.125,694.751 937.792,694.751 879.5,693.5C 877.307,693.719 875.307,694.385 873.5,695.5C 873.833,694.833 874.167,694.167 874.5,693.5C 935.332,692.335 996.332,692.168 1057.5,693C 1060.74,694.736 1063.07,697.236 1064.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d3d4d3",
    d: "M 1580.5,693.5 C 1653.66,692.501 1727,692.167 1800.5,692.5C 1799.12,693.234 1797.62,693.901 1796,694.5C 1724.44,693.951 1652.61,693.618 1580.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9a9a",
    d: "M 874.5,693.5 C 874.167,694.167 873.833,694.833 873.5,695.5C 871.6,697.619 869.934,699.953 868.5,702.5C 868.167,702.5 867.833,702.5 867.5,702.5C 868.163,698.163 870.496,695.163 874.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#bebebe",
    d: "M 1130.5,690.5 C 1131.22,690.918 1131.72,691.584 1132,692.5C 1132.5,695.146 1132.66,697.813 1132.5,700.5C 1132.17,700.5 1131.83,700.5 1131.5,700.5C 1131.5,699.833 1131.5,699.167 1131.5,698.5C 1131.42,695.794 1131.09,693.127 1130.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#bdbdbd",
    d: "M 1221.5,692.5 C 1284.5,692.333 1347.5,692.5 1410.5,693C 1411.53,693.513 1412.53,694.013 1413.5,694.5C 1413.5,694.833 1413.5,695.167 1413.5,695.5C 1410.73,695.579 1408.06,695.079 1405.5,694C 1344.5,693.5 1283.5,693.333 1222.5,693.5C 1222.5,742.833 1222.5,792.167 1222.5,841.5C 1283.17,841.5 1343.83,841.5 1404.5,841.5C 1344,842.499 1283.34,842.832 1222.5,842.5C 1221.5,792.669 1221.17,742.669 1221.5,692.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5f5f",
    d: "M 801.5,693.5 C 801.833,693.5 802.167,693.5 802.5,693.5C 802.064,700 801.398,706.334 800.5,712.5C 800.347,706.131 800.68,699.797 801.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b8b8b8",
    d: "M 801.5,693.5 C 800.68,699.797 800.347,706.131 800.5,712.5C 800.168,778.002 800.501,843.335 801.5,908.5C 801.5,908.833 801.5,909.167 801.5,909.5C 800.078,909.25 799.078,908.417 798.5,907C 799.332,836.57 799.832,766.07 800,695.5C 800.278,694.584 800.778,693.918 801.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a4a4a",
    d: "M 1423.5,705.5 C 1425.34,707.279 1426.01,709.612 1425.5,712.5C 1424.73,710.285 1424.07,707.952 1423.5,705.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b9b9b9",
    d: "M 1490.5,700.5 C 1491.27,701.263 1491.77,702.263 1492,703.5C 1492.67,746.5 1492.67,789.5 1492,832.5C 1491.72,833.416 1491.22,834.082 1490.5,834.5C 1491.83,789.833 1491.83,745.167 1490.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 1489.5,708.5 C 1490.83,747.833 1490.83,787.167 1489.5,826.5C 1488.5,787 1488.5,747.667 1489.5,708.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#676767",
    d: "M 1489.5,698.5 C 1489.83,698.5 1490.17,698.5 1490.5,698.5C 1490.5,699.167 1490.5,699.833 1490.5,700.5C 1491.83,745.167 1491.83,789.833 1490.5,834.5C 1490.5,835.5 1490.5,836.5 1490.5,837.5C 1490.17,837.5 1489.83,837.5 1489.5,837.5C 1489.5,833.833 1489.5,830.167 1489.5,826.5C 1490.83,787.167 1490.83,747.833 1489.5,708.5C 1489.5,705.167 1489.5,701.833 1489.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666666",
    d: "M 867.5,703.5 C 866.631,719.816 866.297,736.15 866.5,752.5C 865.205,736.64 865.205,720.64 866.5,704.5C 866.5,703.833 866.833,703.5 867.5,703.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3a3a3",
    d: "M 1413.5,694.5 C 1418.44,696.719 1421.77,700.386 1423.5,705.5C 1424.07,707.952 1424.73,710.285 1425.5,712.5C 1425.67,750.835 1425.5,789.168 1425,827.5C 1422.52,834.143 1418.02,838.81 1411.5,841.5C 1410.17,841.5 1408.83,841.5 1407.5,841.5C 1417.66,838.5 1423.32,831.667 1424.5,821C 1423.17,785.667 1423.17,750.333 1424.5,715C 1423.48,710.762 1422.14,706.595 1420.5,702.5C 1418.48,699.812 1416.15,697.479 1413.5,695.5C 1413.5,695.167 1413.5,694.833 1413.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d3d3d3",
    d: "M 1580.5,733.5 C 1648.83,733.333 1717.17,733.5 1785.5,734C 1786.83,756.264 1786.83,778.431 1785.5,800.5C 1785.83,778.66 1785.5,756.994 1784.5,735.5C 1716.5,734.833 1648.5,734.167 1580.5,733.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e4e4e",
    d: "M 1579.5,733.5 C 1579.83,733.5 1580.17,733.5 1580.5,733.5C 1648.5,734.167 1716.5,734.833 1784.5,735.5C 1715.83,736.163 1647.49,735.497 1579.5,733.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#ababab",
    d: "M 1064.5,700.5 C 1065.29,701.609 1065.79,702.942 1066,704.5C 1066.5,720.83 1066.67,737.163 1066.5,753.5C 999.665,753.832 932.998,753.499 866.5,752.5C 866.297,736.15 866.631,719.816 867.5,703.5C 867.5,703.167 867.5,702.833 867.5,702.5C 867.833,702.5 868.167,702.5 868.5,702.5C 868.47,718.875 868.47,735.042 868.5,751C 933.833,751.667 999.167,751.667 1064.5,751C 1065.06,750.617 1065.39,750.117 1065.5,749.5C 1065.76,733.143 1065.42,716.809 1064.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d2d2d",
    d: "M 866.5,704.5 C 865.205,720.64 865.205,736.64 866.5,752.5C 932.998,753.499 999.665,753.832 1066.5,753.5C 1066.63,754.239 1066.46,754.906 1066,755.5C 1000.14,754.642 933.976,754.642 867.5,755.5C 866.522,755.023 865.689,754.357 865,753.5C 864.333,737.833 864.333,722.167 865,706.5C 865.278,705.584 865.778,704.918 866.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#383838",
    d: "M 1784.5,735.5 C 1785.5,756.994 1785.83,778.66 1785.5,800.5C 1785.17,800.5 1784.83,800.5 1784.5,800.5C 1716.17,800.5 1647.83,800.5 1579.5,800.5C 1579.5,814.167 1579.5,827.833 1579.5,841.5C 1578.17,827.431 1578.17,813.265 1579.5,799C 1647.83,798.5 1716.17,798.333 1784.5,798.5C 1784.5,777.5 1784.5,756.5 1784.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d3d3d3",
    d: "M 1784.5,800.5 C 1784.83,800.5 1785.17,800.5 1785.5,800.5C 1717.51,802.497 1649.17,803.163 1580.5,802.5C 1648.5,801.833 1716.5,801.167 1784.5,800.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 865.5,819.5 C 865.5,849.167 865.5,878.833 865.5,908.5C 844.833,908.5 824.167,908.5 803.5,908.5C 823.66,907.503 843.993,907.17 864.5,907.5C 864.169,877.995 864.502,848.662 865.5,819.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#adadad",
    d: "M 1131.5,700.5 C 1131.83,700.5 1132.17,700.5 1132.5,700.5C 1132.93,703.166 1133.43,705.832 1134,708.5C 1134.83,775.404 1134.66,842.237 1133.5,909C 1132.13,909.402 1130.79,909.902 1129.5,910.5C 1108.79,909.919 1088.29,909.919 1068,910.5C 1067.08,909.953 1066.24,909.287 1065.5,908.5C 1064.17,879.5 1064.17,850.5 1065.5,821.5C 999.503,820.5 933.503,820.167 867.5,820.5C 867.5,820.167 867.5,819.833 867.5,819.5C 933.833,819.5 1000.17,819.5 1066.5,819.5C 1066.5,849.167 1066.5,878.833 1066.5,908.5C 1088.17,908.5 1109.83,908.5 1131.5,908.5C 1131.5,839.167 1131.5,769.833 1131.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656565",
    d: "M 865.5,819.5 C 866.167,819.5 866.833,819.5 867.5,819.5C 867.5,819.833 867.5,820.167 867.5,820.5C 866.833,849.833 866.167,879.167 865.5,908.5C 865.5,878.833 865.5,849.167 865.5,819.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787878",
    d: "M 1489.5,838.5 C 1489.48,840.565 1489.15,842.565 1488.5,844.5C 1488.5,844.833 1488.5,845.167 1488.5,845.5C 1488.17,845.5 1487.83,845.5 1487.5,845.5C 1487.41,842.848 1488.08,840.515 1489.5,838.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#c8c8c8",
    d: "M 1489.5,837.5 C 1489.83,837.5 1490.17,837.5 1490.5,837.5C 1490.66,839.527 1490.5,841.527 1490,843.5C 1489.62,844.056 1489.12,844.389 1488.5,844.5C 1489.15,842.565 1489.48,840.565 1489.5,838.5C 1489.5,838.167 1489.5,837.833 1489.5,837.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c2c2c",
    d: "M 1221.5,692.5 C 1221.17,742.669 1221.5,792.669 1222.5,842.5C 1283.33,843.499 1344.33,843.832 1405.5,843.5C 1404.12,844.234 1402.62,844.901 1401,845.5C 1341.05,845.546 1280.88,845.213 1220.5,844.5C 1220.17,793.664 1220.5,742.997 1221.5,692.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a9a9a9",
    d: "M 1784.5,800.5 C 1716.5,801.167 1648.5,801.833 1580.5,802.5C 1580.5,815.5 1580.5,828.5 1580.5,841.5C 1653.17,841.5 1725.83,841.5 1798.5,841.5C 1798.5,841.833 1798.5,842.167 1798.5,842.5C 1725.5,842.5 1652.5,842.5 1579.5,842.5C 1579.5,842.167 1579.5,841.833 1579.5,841.5C 1579.5,827.833 1579.5,814.167 1579.5,800.5C 1647.83,800.5 1716.17,800.5 1784.5,800.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#777777",
    d: "M 1404.5,841.5 C 1405.5,841.5 1406.5,841.5 1407.5,841.5C 1408.83,841.5 1410.17,841.5 1411.5,841.5C 1409.5,842.167 1407.5,842.833 1405.5,843.5C 1344.33,843.832 1283.33,843.499 1222.5,842.5C 1283.34,842.832 1344,842.499 1404.5,841.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646464",
    d: "M 1579.5,843.5 C 1579.5,843.167 1579.5,842.833 1579.5,842.5C 1652.5,842.5 1725.5,842.5 1798.5,842.5C 1799.17,842.5 1799.5,842.833 1799.5,843.5C 1799.5,844.167 1799.5,844.833 1799.5,845.5C 1799.17,845.5 1798.83,845.5 1798.5,845.5C 1725.84,843.503 1652.84,842.836 1579.5,843.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#d3d3d3",
    d: "M 1798.5,842.5 C 1798.5,842.167 1798.5,841.833 1798.5,841.5C 1799.5,841.414 1800.33,841.748 1801,842.5C 1801.83,865.004 1801.66,887.337 1800.5,909.5C 1800.83,887.327 1800.5,865.327 1799.5,843.5C 1799.5,842.833 1799.17,842.5 1798.5,842.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202120",
    d: "M 1579.5,843.5 C 1652.84,842.836 1725.84,843.503 1798.5,845.5C 1726.17,845.056 1654,845.056 1582,845.5C 1581.01,844.934 1580.17,844.267 1579.5,843.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#373737",
    d: "M 1486.5,848.5 C 1486.2,850.403 1485.54,852.07 1484.5,853.5C 1483.18,851.124 1483.85,849.457 1486.5,848.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b5b5b5",
    d: "M 1487.5,845.5 C 1487.83,845.5 1488.17,845.5 1488.5,845.5C 1488.66,847.199 1488.49,848.866 1488,850.5C 1487.08,853.557 1485.58,856.224 1483.5,858.5C 1483.37,856.708 1483.7,855.042 1484.5,853.5C 1485.54,852.07 1486.2,850.403 1486.5,848.5C 1487.4,847.791 1487.74,846.791 1487.5,845.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#a1a1a1",
    d: "M 1483.5,858.5 C 1473.75,878.915 1458.42,893.581 1437.5,902.5C 1437.83,901.833 1438.17,901.167 1438.5,900.5C 1441.54,897.678 1445.21,895.844 1449.5,895C 1457.66,888.666 1465.33,881.832 1472.5,874.5C 1476.34,869.232 1480.01,863.899 1483.5,858.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d3d3d",
    d: "M 1438.5,900.5 C 1438.17,901.167 1437.83,901.833 1437.5,902.5C 1434.31,902.405 1431.31,903.071 1428.5,904.5C 1429.06,903.21 1430.06,902.377 1431.5,902C 1433.87,901.56 1436.2,901.06 1438.5,900.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#b7b7b7",
    d: "M 1437.5,902.5 C 1434.86,904.31 1431.86,905.31 1428.5,905.5C 1428.5,905.167 1428.5,904.833 1428.5,904.5C 1431.31,903.071 1434.31,902.405 1437.5,902.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#a6a6a6",
    d: "M 1818.5,881.5 C 1826.03,869.413 1836.37,866.58 1849.5,873C 1857.11,879.058 1859.61,886.891 1857,896.5C 1849.93,910.048 1839.43,913.548 1825.5,907C 1817.07,899.754 1814.74,891.254 1818.5,881.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#151515",
    d: "M 1818.5,881.5 C 1821.51,878.356 1824.84,875.523 1828.5,873C 1838.62,869.275 1847.12,871.442 1854,879.5C 1859.57,897.928 1852.74,907.428 1833.5,908C 1830.83,907 1828.17,906 1825.5,905C 1818.94,898.589 1816.61,890.755 1818.5,881.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919191",
    d: "M 1847.5,878.5 C 1854.15,886.088 1854.15,893.755 1847.5,901.5C 1842.31,905.551 1836.64,906.384 1830.5,904C 1828.36,903.124 1827.03,901.624 1826.5,899.5C 1832.59,904.791 1838.92,905.291 1845.5,901C 1844.17,900.667 1842.83,900.333 1841.5,900C 1840.42,897.09 1838.75,894.59 1836.5,892.5C 1835.69,894.766 1835.19,897.1 1835,899.5C 1833.38,900.801 1831.88,900.801 1830.5,899.5C 1831.82,899.67 1832.99,899.337 1834,898.5C 1834.5,896.19 1834.66,893.857 1834.5,891.5C 1839.06,891.554 1841.56,893.888 1842,898.5C 1843.01,899.337 1844.18,899.67 1845.5,899.5C 1845.87,896.028 1844.87,893.028 1842.5,890.5C 1846.43,887.29 1846.43,884.123 1842.5,881C 1838.51,880.501 1834.51,880.334 1830.5,880.5C 1834.65,879.353 1838.98,879.186 1843.5,880C 1847.06,883.182 1847.39,886.682 1844.5,890.5C 1845.75,893.07 1846.75,895.737 1847.5,898.5C 1849.63,895.74 1850.96,892.573 1851.5,889C 1850.24,885.445 1848.91,881.945 1847.5,878.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M 1824.5,896.5 C 1825.91,896.973 1826.57,897.973 1826.5,899.5C 1825.09,899.027 1824.43,898.027 1824.5,896.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#141414",
    d: "M 1830.5,880.5 C 1834.51,880.334 1838.51,880.501 1842.5,881C 1846.43,884.123 1846.43,887.29 1842.5,890.5C 1844.87,893.028 1845.87,896.028 1845.5,899.5C 1844.18,899.67 1843.01,899.337 1842,898.5C 1841.56,893.888 1839.06,891.554 1834.5,891.5C 1834.66,893.857 1834.5,896.19 1834,898.5C 1832.99,899.337 1831.82,899.67 1830.5,899.5C 1830.5,893.167 1830.5,886.833 1830.5,880.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9d9d",
    d: "M 1840.5,875.5 C 1843.31,875.025 1845.31,876.025 1846.5,878.5C 1844.46,877.492 1842.46,876.492 1840.5,875.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 1840.5,875.5 C 1842.46,876.492 1844.46,877.492 1846.5,878.5C 1846.83,878.5 1847.17,878.5 1847.5,878.5C 1848.91,881.945 1850.24,885.445 1851.5,889C 1850.96,892.573 1849.63,895.74 1847.5,898.5C 1846.75,895.737 1845.75,893.07 1844.5,890.5C 1847.39,886.682 1847.06,883.182 1843.5,880C 1838.98,879.186 1834.65,879.353 1830.5,880.5C 1830.5,886.833 1830.5,893.167 1830.5,899.5C 1831.88,900.801 1833.38,900.801 1835,899.5C 1835.19,897.1 1835.69,894.766 1836.5,892.5C 1838.75,894.59 1840.42,897.09 1841.5,900C 1842.83,900.333 1844.17,900.667 1845.5,901C 1838.92,905.291 1832.59,904.791 1826.5,899.5C 1826.57,897.973 1825.91,896.973 1824.5,896.5C 1821.8,886.756 1824.96,879.756 1834,875.5C 1836.11,876.598 1838.28,876.598 1840.5,875.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#818181",
    d: "M 1840.5,887.5 C 1839.01,889.28 1837.01,889.946 1834.5,889.5C 1834.5,887.167 1834.5,884.833 1834.5,882.5C 1836.65,882.372 1838.65,882.872 1840.5,884C 1841.79,885.292 1841.79,886.458 1840.5,887.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0f0f0",
    d: "M 1840.5,887.5 C 1839.07,887.421 1837.74,887.754 1836.5,888.5C 1835.57,887.311 1835.24,885.978 1835.5,884.5C 1838.03,884.259 1839.7,885.259 1840.5,887.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M 1840.5,875.5 C 1838.28,876.598 1836.11,876.598 1834,875.5C 1824.96,879.756 1821.8,886.756 1824.5,896.5C 1819.82,886.759 1822.49,879.593 1832.5,875C 1835.37,874.199 1838.03,874.366 1840.5,875.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222222",
    d: "M 1155.5,906.5 C 1241.13,907.495 1326.79,907.828 1412.5,907.5C 1327.33,908.499 1242,908.833 1156.5,908.5C 1156.17,908.5 1155.83,908.5 1155.5,908.5C 1155.5,907.833 1155.5,907.167 1155.5,906.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#b1b1b1",
    d: "M 867.5,820.5 C 868.65,849.791 868.817,879.125 868,908.5C 866.559,909.26 865.059,909.926 863.5,910.5C 842.501,910.826 821.834,910.493 801.5,909.5C 801.5,909.167 801.5,908.833 801.5,908.5C 802.167,908.5 802.833,908.5 803.5,908.5C 824.167,908.5 844.833,908.5 865.5,908.5C 866.167,879.167 866.833,849.833 867.5,820.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#a2a2a2",
    d: "M 1428.5,904.5 C 1428.5,904.833 1428.5,905.167 1428.5,905.5C 1424.94,906.908 1421.27,908.075 1417.5,909C 1412.91,909.197 1408.41,909.697 1404,910.5C 1321.52,910.456 1239.02,910.123 1156.5,909.5C 1156.5,909.167 1156.5,908.833 1156.5,908.5C 1242,908.833 1327.33,908.499 1412.5,907.5C 1417.84,906.664 1423.17,905.664 1428.5,904.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#9f9f9f",
    d: "M 1799.5,843.5 C 1800.5,865.327 1800.83,887.327 1800.5,909.5C 1704.8,909.562 1609.47,909.562 1514.5,909.5C 1514.5,909.167 1514.5,908.833 1514.5,908.5C 1609.5,908.5 1704.5,908.5 1799.5,908.5C 1799.5,887.5 1799.5,866.5 1799.5,845.5C 1799.5,844.833 1799.5,844.167 1799.5,843.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerade);
export default __webpack_public_path__ + "static/media/powerade.5cb776ff890bcfd08de1c2835fef9cda.svg";
export { ForwardRef as ReactComponent };